/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from './booking-payroll.component.css.shim.ngstyle';
import * as import1 from '@angular/core';
import * as import2 from '../payroll-additional-costs/payroll-additional-costs.component.ngfactory';
import * as import3 from '../../../../app/booking-management/payroll-additional-costs/payroll-additional-costs.component';
import * as import4 from '../booking-rate-calculation /booking-rate-calulation.component.ngfactory';
import * as import5 from '../../../../app/booking-management/booking-rate-calculation /booking-rate-calulation.component';
import * as import6 from '../../../../$$_gendir/node_modules/@angular/material/typings/index.ngfactory';
import * as import7 from '@angular/material';
import * as import8 from '@angular/forms';
import * as import9 from 'md2/core/compatibility/compatibility';
import * as import10 from '@angular/common';
import * as import11 from '../payroll-time/payroll-time.component.ngfactory';
import * as import12 from '../../../../app/booking-management/payroll-time/payroll-time.component';
import * as import13 from '../../../../app/shared/pipe/moment-tzdate.pipe';
import * as import14 from '../booking-header/booking-header.component.ngfactory';
import * as import15 from '../../../../app/booking-management/booking-header/booking-header.component';
import * as import16 from '../../../../app/booking-management/booking-header/booking-header.service';
import * as import17 from '@angular/router';
import * as import18 from '../../../../app/notification/notification.service';
import * as import19 from '../booking-info/booking-info.component.ngfactory';
import * as import20 from '../../../../app/booking-management/booking-info/booking-info.component';
import * as import21 from '../../../../app/booking-management/booking-payroll/booking-payroll.component';
import * as import22 from '../../../../app/spinner/spinner.service';
import * as import23 from '../../../../app/api/booking.service';
const styles_BookingPayrollComponent:any[] = [import0.styles];
export const RenderType_BookingPayrollComponent:import1.RendererType2 = import1.ɵcrt({
  encapsulation: 0,
  styles: styles_BookingPayrollComponent,
  data: {}
}
);
function View_BookingPayrollComponent_2(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
      (l()(),import1.ɵeld(0,(null as any),(null as any),1,'span',[[
        'class',
        'note note_block note_green note_small'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['RECOMMENDED']))
  ]
  ,(null as any),(null as any));
}
function View_BookingPayrollComponent_3(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
      (l()(),import1.ɵeld(0,(null as any),(null as any),1,'span',[[
        'class',
        'note note_block note_small'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['NOT RECOMMENDED']))
  ]
  ,(null as any),(null as any));
}
function View_BookingPayrollComponent_4(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
      (l()(),import1.ɵeld(0,(null as any),(null as any),1,'span',[[
        'class',
        'note note_block note_green note_small'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['RECOMMENDED']))
  ]
  ,(null as any),(null as any));
}
function View_BookingPayrollComponent_5(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
      (l()(),import1.ɵeld(0,(null as any),(null as any),1,'span',[[
        'class',
        'note note_block note_small'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['NOT RECOMMENDED']))
  ]
  ,(null as any),(null as any));
}
function View_BookingPayrollComponent_6(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'app-payroll-additional-costs',([] as any[]),(null as any),(null as any),(null as any),import2.View_PayrollAdditionalCostsComponent_0,import2.RenderType_PayrollAdditionalCostsComponent)),
    import1.ɵdid(114688,(null as any),0,import3.PayrollAdditionalCostsComponent,([] as any[]),{
      payrollInvoice: [
        0,
        'payrollInvoice'
      ]
      ,
      index: [
        1,
        'index'
      ]
      ,
      parentForm: [
        2,
        'parentForm'
      ]
      ,
      isReadOnly: [
        3,
        'isReadOnly'
      ]

    }
    ,(null as any))
  ]
  ,(ck,v) => {
    const currVal_0:any = (<any>v.parent).context.$implicit;
    const currVal_1:any = (<any>v.parent).context.index;
    const currVal_2:any = import1.ɵnov((<any>(<any>v.parent).parent),13);
    const currVal_3:boolean = !(<any>v.parent).context.$implicit.pay_interpreter;
    ck(v,1,0,currVal_0,currVal_1,currVal_2,currVal_3);
  },(null as any));
}
function View_BookingPayrollComponent_7(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
    (l()(),import1.ɵeld(0,(null as any),(null as any),2,'app-booking-rate-calulation',([] as any[]),(null as any),(null as any),(null as any),import4.View_BookingRateCalulationComponent_0,import4.RenderType_BookingRateCalulationComponent)),
    import1.ɵdid(114688,(null as any),0,import5.BookingRateCalulationComponent,([] as any[]),{
      payrollInvoice: [
        0,
        'payrollInvoice'
      ]
      ,
      index: [
        1,
        'index'
      ]
      ,
      parentForm: [
        2,
        'parentForm'
      ]
      ,
      isReadOnly: [
        3,
        'isReadOnly'
      ]

    }
    ,(null as any)),
    (l()(),import1.ɵted((null as any),['\n                                \n                            ']))
  ]
  ,(ck,v) => {
    const currVal_0:any = (<any>v.parent).context.$implicit;
    const currVal_1:any = (<any>v.parent).context.index;
    const currVal_2:any = import1.ɵnov((<any>(<any>v.parent).parent),13);
    const currVal_3:boolean = !(<any>v.parent).context.$implicit.pay_interpreter;
    ck(v,1,0,currVal_0,currVal_1,currVal_2,currVal_3);
  },(null as any));
}
function View_BookingPayrollComponent_9(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
      (l()(),import1.ɵeld(0,(null as any),(null as any),1,'span',[[
        'class',
        'note note_block note_green note_small'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['RECOMMENDED']))
  ]
  ,(null as any),(null as any));
}
function View_BookingPayrollComponent_10(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
      (l()(),import1.ɵeld(0,(null as any),(null as any),1,'span',[[
        'class',
        'note note_block note_small'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['NOT RECOMMENDED']))
  ]
  ,(null as any),(null as any));
}
function View_BookingPayrollComponent_11(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
      (l()(),import1.ɵeld(0,(null as any),(null as any),1,'span',[[
        'class',
        'note note_block note_green note_small'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['RECOMMENDED']))
  ]
  ,(null as any),(null as any));
}
function View_BookingPayrollComponent_12(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
      (l()(),import1.ɵeld(0,(null as any),(null as any),1,'span',[[
        'class',
        'note note_block note_small'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['NOT RECOMMENDED']))
  ]
  ,(null as any),(null as any));
}
function View_BookingPayrollComponent_13(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
    (l()(),import1.ɵeld(0,(null as any),(null as any),2,'app-payroll-additional-costs',([] as any[]),(null as any),(null as any),(null as any),import2.View_PayrollAdditionalCostsComponent_0,import2.RenderType_PayrollAdditionalCostsComponent)),
    import1.ɵdid(114688,(null as any),0,import3.PayrollAdditionalCostsComponent,([] as any[]),{
      payrollInvoice: [
        0,
        'payrollInvoice'
      ]
      ,
      index: [
        1,
        'index'
      ]
      ,
      isClient: [
        2,
        'isClient'
      ]
      ,
      parentForm: [
        3,
        'parentForm'
      ]
      ,
      isReadOnly: [
        4,
        'isReadOnly'
      ]

    }
    ,(null as any)),
    (l()(),import1.ɵted((null as any),['\n                                \n                            ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.payments.invoice_attributes[(<any>(<any>v.parent).parent).context.index];
    const currVal_1:any = (<any>(<any>v.parent).parent).context.index;
    const currVal_2:any = true;
    const currVal_3:any = import1.ɵnov((<any>(<any>(<any>v.parent).parent).parent),13);
    const currVal_4:boolean = !co.payments.invoice_attributes[(<any>(<any>v.parent).parent).context.index].invoice_client;
    ck(v,1,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4);
  },(null as any));
}
function View_BookingPayrollComponent_14(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
    (l()(),import1.ɵeld(0,(null as any),(null as any),2,'app-booking-rate-calulation',([] as any[]),(null as any),(null as any),(null as any),import4.View_BookingRateCalulationComponent_0,import4.RenderType_BookingRateCalulationComponent)),
    import1.ɵdid(114688,(null as any),0,import5.BookingRateCalulationComponent,([] as any[]),{
      payrollInvoice: [
        0,
        'payrollInvoice'
      ]
      ,
      index: [
        1,
        'index'
      ]
      ,
      isClient: [
        2,
        'isClient'
      ]
      ,
      parentForm: [
        3,
        'parentForm'
      ]
      ,
      isReadOnly: [
        4,
        'isReadOnly'
      ]

    }
    ,(null as any)),
    (l()(),import1.ɵted((null as any),['\n                                \n                            ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.payments.invoice_attributes[(<any>(<any>v.parent).parent).context.index];
    const currVal_1:any = (<any>(<any>v.parent).parent).context.index;
    const currVal_2:any = true;
    const currVal_3:any = import1.ɵnov((<any>(<any>(<any>v.parent).parent).parent),13);
    const currVal_4:boolean = !co.payments.invoice_attributes[(<any>(<any>v.parent).parent).context.index].invoice_client;
    ck(v,1,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4);
  },(null as any));
}
function View_BookingPayrollComponent_8(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
      (l()(),import1.ɵeld(0,(null as any),(null as any),62,'section',[[
        'class',
        'payroll-card__client'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n                            '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),6,'header',[
      [
        'class',
        'payroll-card__header'
      ]
      ,
      [
        'id',
        'client-invoice'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),[
      'Invoice ',
      ': ',
      ' for ',
      ''
    ]
    )),
    (l()(),import1.ɵeld(0,(null as any),(null as any),0,'br',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n                                '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),1,'span',[[
        'class',
        'payroll_id'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),[
      'ID: ',
      ''
    ]
    )),
    (l()(),import1.ɵted((null as any),['\n                            '])),
    (l()(),import1.ɵted((null as any),['\n                            '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),42,'section',[[
        'class',
        'payroll-card__content'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n                                '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),39,'section',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n                                    '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),17,'div',[[
        'class',
        'payroll-card__option'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n                                        '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),14,'md-checkbox',[[
        'class',
        'mat-checkbox'
      ]
    ],[
      [
        2,
        'mat-checkbox-indeterminate',
        (null as any)
      ]
      ,
      [
        2,
        'mat-checkbox-checked',
        (null as any)
      ]
      ,
      [
        2,
        'mat-checkbox-disabled',
        (null as any)
      ]
      ,
      [
        2,
        'mat-checkbox-label-before',
        (null as any)
      ]
      ,
      [
        2,
        'ng-untouched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-touched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pristine',
        (null as any)
      ]
      ,
      [
        2,
        'ng-dirty',
        (null as any)
      ]
      ,
      [
        2,
        'ng-valid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-invalid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pending',
        (null as any)
      ]

    ]
    ,[
      [
        (null as any),
        'ngModelChange'
      ]
      ,
      [
        (null as any),
        'change'
      ]

    ]
    ,(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('ngModelChange' === en)) {
        const pd_0:any = ((<any>(co.payments.invoice_attributes[(<any>v.parent).context.index].invoice_client = $event)) !== false);
        ad = (pd_0 && ad);
      }
      if (('change' === en)) {
        const pd_1:any = ((<any>co.cbChanged('invoice_attributes','invoice_client',(<any>v.parent).context.index)) !== false);
        ad = (pd_1 && ad);
      }
      return ad;
    },import6.View_MdCheckbox_0,import6.RenderType_MdCheckbox)),
    import1.ɵdid(16384,(null as any),0,import7.MdPrefixRejector,[
      [
        2,
        import7.MATERIAL_COMPATIBILITY_MODE
      ]
      ,
      import1.ElementRef
    ]
    ,(null as any),(null as any)),
    import1.ɵdid(4374528,(null as any),0,import7.MdCheckbox,[
      import1.Renderer2,
      import1.ElementRef,
      import1.ChangeDetectorRef,
      import7.FocusOriginMonitor
    ]
      ,{name: [
        0,
        'name'
      ]
    },{change: 'change'}),
    import1.ɵprd(1024,(null as any),import8.NG_VALUE_ACCESSOR,(p0_0:any) => {
      return [p0_0];
    },[import7.MdCheckbox]),
    import1.ɵdid(671744,(null as any),0,import8.NgModel,[
      [
        2,
        import8.ControlContainer
      ]
      ,
      [
        8,
        (null as any)
      ]
      ,
      [
        8,
        (null as any)
      ]
      ,
      [
        2,
        import8.NG_VALUE_ACCESSOR
      ]

    ]
    ,{
      name: [
        0,
        'name'
      ]
      ,
      model: [
        1,
        'model'
      ]

    }
    ,{update: 'ngModelChange'}),
    import1.ɵprd(2048,(null as any),import8.NgControl,(null as any),[import8.NgModel]),
    import1.ɵdid(16384,(null as any),0,import8.NgControlStatus,[import8.NgControl],(null as any),(null as any)),
      import1.ɵdid(16384,(null as any),0,import9.MdPrefixRejector,[[
        2,
        import9.MATERIAL_COMPATIBILITY_MODE
      ]
    ],(null as any),(null as any)),
    (l()(),import1.ɵted(0,['\n                                            Invoice client\n                                            '])),
    (l()(),import1.ɵand(16777216,(null as any),0,1,(null as any),View_BookingPayrollComponent_9)),
    import1.ɵdid(16384,(null as any),0,import10.NgIf,[
      import1.ViewContainerRef,
      import1.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import1.ɵted(0,['\n                                            '])),
    (l()(),import1.ɵand(16777216,(null as any),0,1,(null as any),View_BookingPayrollComponent_10)),
    import1.ɵdid(16384,(null as any),0,import10.NgIf,[
      import1.ViewContainerRef,
      import1.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import1.ɵted(0,['\n                                        '])),
    (l()(),import1.ɵted((null as any),['\n\n                                    '])),
    (l()(),import1.ɵted((null as any),['\n                                    '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),17,'div',[[
        'class',
        'payroll-card__option payroll-card__option_with-offset'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n                                        '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),14,'md-checkbox',[[
        'class',
        'mat-checkbox'
      ]
    ],[
      [
        2,
        'mat-checkbox-indeterminate',
        (null as any)
      ]
      ,
      [
        2,
        'mat-checkbox-checked',
        (null as any)
      ]
      ,
      [
        2,
        'mat-checkbox-disabled',
        (null as any)
      ]
      ,
      [
        2,
        'mat-checkbox-label-before',
        (null as any)
      ]
      ,
      [
        2,
        'ng-untouched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-touched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pristine',
        (null as any)
      ]
      ,
      [
        2,
        'ng-dirty',
        (null as any)
      ]
      ,
      [
        2,
        'ng-valid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-invalid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pending',
        (null as any)
      ]

    ]
    ,[
      [
        (null as any),
        'ngModelChange'
      ]
      ,
      [
        (null as any),
        'change'
      ]

    ]
    ,(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('ngModelChange' === en)) {
        const pd_0:any = ((<any>(co.payments.invoice_attributes[(<any>v.parent).context.index].charge_travel = $event)) !== false);
        ad = (pd_0 && ad);
      }
      if (('change' === en)) {
        const pd_1:any = ((<any>co.cbChanged('invoice_attributes','charge_travel',(<any>v.parent).context.index)) !== false);
        ad = (pd_1 && ad);
      }
      return ad;
    },import6.View_MdCheckbox_0,import6.RenderType_MdCheckbox)),
    import1.ɵdid(16384,(null as any),0,import7.MdPrefixRejector,[
      [
        2,
        import7.MATERIAL_COMPATIBILITY_MODE
      ]
      ,
      import1.ElementRef
    ]
    ,(null as any),(null as any)),
    import1.ɵdid(4374528,(null as any),0,import7.MdCheckbox,[
      import1.Renderer2,
      import1.ElementRef,
      import1.ChangeDetectorRef,
      import7.FocusOriginMonitor
    ]
    ,{
      disabled: [
        0,
        'disabled'
      ]
      ,
      name: [
        1,
        'name'
      ]

    }
    ,{change: 'change'}),
    import1.ɵprd(1024,(null as any),import8.NG_VALUE_ACCESSOR,(p0_0:any) => {
      return [p0_0];
    },[import7.MdCheckbox]),
    import1.ɵdid(671744,(null as any),0,import8.NgModel,[
      [
        2,
        import8.ControlContainer
      ]
      ,
      [
        8,
        (null as any)
      ]
      ,
      [
        8,
        (null as any)
      ]
      ,
      [
        2,
        import8.NG_VALUE_ACCESSOR
      ]

    ]
    ,{
      name: [
        0,
        'name'
      ]
      ,
      isDisabled: [
        1,
        'isDisabled'
      ]
      ,
      model: [
        2,
        'model'
      ]

    }
    ,{update: 'ngModelChange'}),
    import1.ɵprd(2048,(null as any),import8.NgControl,(null as any),[import8.NgModel]),
    import1.ɵdid(16384,(null as any),0,import8.NgControlStatus,[import8.NgControl],(null as any),(null as any)),
      import1.ɵdid(16384,(null as any),0,import9.MdPrefixRejector,[[
        2,
        import9.MATERIAL_COMPATIBILITY_MODE
      ]
    ],(null as any),(null as any)),
    (l()(),import1.ɵted(0,['\n                                            Charge travel\n                                            '])),
    (l()(),import1.ɵand(16777216,(null as any),0,1,(null as any),View_BookingPayrollComponent_11)),
    import1.ɵdid(16384,(null as any),0,import10.NgIf,[
      import1.ViewContainerRef,
      import1.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import1.ɵted(0,['\n                                            '])),
    (l()(),import1.ɵand(16777216,(null as any),0,1,(null as any),View_BookingPayrollComponent_12)),
    import1.ɵdid(16384,(null as any),0,import10.NgIf,[
      import1.ViewContainerRef,
      import1.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import1.ɵted(0,['\n                                        '])),
    (l()(),import1.ɵted((null as any),['\n                                    '])),
    (l()(),import1.ɵted((null as any),['\n                                '])),
    (l()(),import1.ɵted((null as any),['\n                            '])),
    (l()(),import1.ɵted((null as any),['\n                            '])),
    (l()(),import1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_BookingPayrollComponent_13)),
    import1.ɵdid(16384,(null as any),0,import10.NgIf,[
      import1.ViewContainerRef,
      import1.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import1.ɵted((null as any),['\n                            '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'app-payroll-time',([] as any[]),(null as any),(null as any),(null as any),import11.View_PayrollTimeComponent_0,import11.RenderType_PayrollTimeComponent)),
    import1.ɵdid(4308992,(null as any),0,import12.PayrollTimeComponent,([] as any[]),{
      payrollInvoice: [
        0,
        'payrollInvoice'
      ]
      ,
      index: [
        1,
        'index'
      ]
      ,
      isClient: [
        2,
        'isClient'
      ]
      ,
      parentForm: [
        3,
        'parentForm'
      ]
      ,
      isReadOnly: [
        4,
        'isReadOnly'
      ]

    }
    ,(null as any)),
    (l()(),import1.ɵted((null as any),['\n                            '])),
    (l()(),import1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_BookingPayrollComponent_14)),
    import1.ɵdid(16384,(null as any),0,import10.NgIf,[
      import1.ViewContainerRef,
      import1.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import1.ɵted((null as any),['\n                        ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_15:any = import1.ɵinlineInterpolate(1,'',('cbInvoiceClient_' + (<any>v.parent).context.index),'');
    ck(v,18,0,currVal_15);
    const currVal_16:any = import1.ɵinlineInterpolate(1,'',('cbInvoiceClient_' + (<any>v.parent).context.index),'');
    const currVal_17:any = co.payments.invoice_attributes[(<any>v.parent).context.index].invoice_client;
    ck(v,20,0,currVal_16,currVal_17);
    const currVal_18:any = co.payments.invoice_attributes[(<any>v.parent).context.index].recommended.invoice_client;
    ck(v,26,0,currVal_18);
    const currVal_19:boolean = !co.payments.invoice_attributes[(<any>v.parent).context.index].recommended.invoice_client;
    ck(v,29,0,currVal_19);
    const currVal_31:boolean = !co.payments.invoice_attributes[(<any>v.parent).context.index].invoice_client;
    const currVal_32:any = import1.ɵinlineInterpolate(1,'',('cbChargeTravel_' + (<any>v.parent).context.index),'');
    ck(v,37,0,currVal_31,currVal_32);
    const currVal_33:any = import1.ɵinlineInterpolate(1,'',('cbChargeTravel_' + (<any>v.parent).context.index),'');
    const currVal_34:boolean = !co.payments.invoice_attributes[(<any>v.parent).context.index].invoice_client;
    const currVal_35:any = co.payments.invoice_attributes[(<any>v.parent).context.index].charge_travel;
    ck(v,39,0,currVal_33,currVal_34,currVal_35);
    const currVal_36:any = co.payments.invoice_attributes[(<any>v.parent).context.index].recommended.charge_travel;
    ck(v,45,0,currVal_36);
    const currVal_37:boolean = !co.payments.invoice_attributes[(<any>v.parent).context.index].recommended.charge_travel;
    ck(v,48,0,currVal_37);
    const currVal_38:any = co.isDSQ;
    ck(v,55,0,currVal_38);
    const currVal_39:any = co.payments.invoice_attributes[(<any>v.parent).context.index];
    const currVal_40:any = (<any>v.parent).context.index;
    const currVal_41:any = true;
    const currVal_42:any = import1.ɵnov((<any>(<any>v.parent).parent),13);
    const currVal_43:boolean = !co.payments.invoice_attributes[(<any>v.parent).context.index].invoice_client;
    ck(v,58,0,currVal_39,currVal_40,currVal_41,currVal_42,currVal_43);
    const currVal_44:any = co.isDSQ;
    ck(v,61,0,currVal_44);
  },(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = ((<any>v.parent).context.index + 1);
    const currVal_1:any = co.payments.invoice_attributes[(<any>v.parent).context.index].organisation_name;
    const currVal_2:any = (((<any>v.parent).context.$implicit.interpreter_first_name + ' ') + (<any>v.parent).context.$implicit.interpreter_last_name);
    ck(v,3,0,currVal_0,currVal_1,currVal_2);
    const currVal_3:any = co.payments.invoice_attributes[(<any>v.parent).context.index].id;
    ck(v,7,0,currVal_3);
    const currVal_4:any = import1.ɵnov(v,18).indeterminate;
    const currVal_5:any = import1.ɵnov(v,18).checked;
    const currVal_6:any = import1.ɵnov(v,18).disabled;
    const currVal_7:any = (import1.ɵnov(v,18).labelPosition == 'before');
    const currVal_8:any = import1.ɵnov(v,22).ngClassUntouched;
    const currVal_9:any = import1.ɵnov(v,22).ngClassTouched;
    const currVal_10:any = import1.ɵnov(v,22).ngClassPristine;
    const currVal_11:any = import1.ɵnov(v,22).ngClassDirty;
    const currVal_12:any = import1.ɵnov(v,22).ngClassValid;
    const currVal_13:any = import1.ɵnov(v,22).ngClassInvalid;
    const currVal_14:any = import1.ɵnov(v,22).ngClassPending;
    ck(v,16,1,[
      currVal_4,
      currVal_5,
      currVal_6,
      currVal_7,
      currVal_8,
      currVal_9,
      currVal_10,
      currVal_11,
      currVal_12,
      currVal_13,
      currVal_14
    ]
    );
    const currVal_20:any = import1.ɵnov(v,37).indeterminate;
    const currVal_21:any = import1.ɵnov(v,37).checked;
    const currVal_22:any = import1.ɵnov(v,37).disabled;
    const currVal_23:any = (import1.ɵnov(v,37).labelPosition == 'before');
    const currVal_24:any = import1.ɵnov(v,41).ngClassUntouched;
    const currVal_25:any = import1.ɵnov(v,41).ngClassTouched;
    const currVal_26:any = import1.ɵnov(v,41).ngClassPristine;
    const currVal_27:any = import1.ɵnov(v,41).ngClassDirty;
    const currVal_28:any = import1.ɵnov(v,41).ngClassValid;
    const currVal_29:any = import1.ɵnov(v,41).ngClassInvalid;
    const currVal_30:any = import1.ɵnov(v,41).ngClassPending;
    ck(v,35,1,[
      currVal_20,
      currVal_21,
      currVal_22,
      currVal_23,
      currVal_24,
      currVal_25,
      currVal_26,
      currVal_27,
      currVal_28,
      currVal_29,
      currVal_30
    ]
    );
  });
}
function View_BookingPayrollComponent_1(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
      (l()(),import1.ɵeld(0,(null as any),(null as any),92,'section',[[
        'class',
        'payroll-card'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n                        '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),86,'section',[[
        'class',
        'payroll-card__interpreter'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n                            '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),6,'header',[[
        'class',
        'payroll-card__header'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),[
      'Interpreter ',
      ': ',
      ''
    ]
    )),
    (l()(),import1.ɵeld(0,(null as any),(null as any),0,'br',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n                                '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),1,'span',[[
        'class',
        'payroll_id'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),[
      'ID: ',
      ''
    ]
    )),
    (l()(),import1.ɵted((null as any),['\n                            '])),
    (l()(),import1.ɵted((null as any),['\n                            '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),66,'section',[[
        'class',
        'payroll-card__content'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n                                '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),16,'section',[[
        'class',
        'common-form'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n                                    PAYROLL AS\n                                    '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),13,'div',[[
        'class',
        'form-field'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n                                        '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),11,'select',[
      [
        'class',
        'menu custom gray'
      ]
      ,
      [
        'disabled',
        ''
      ]

    ]
    ,[
      [
        2,
        'ng-untouched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-touched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pristine',
        (null as any)
      ]
      ,
      [
        2,
        'ng-dirty',
        (null as any)
      ]
      ,
      [
        2,
        'ng-valid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-invalid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pending',
        (null as any)
      ]

    ]
    ,[
      [
        (null as any),
        'ngModelChange'
      ]
      ,
      [
        (null as any),
        'change'
      ]
      ,
      [
        (null as any),
        'blur'
      ]

    ]
    ,(v,en,$event) => {
      var ad:boolean = true;
      if (('change' === en)) {
        const pd_0:any = ((<any>import1.ɵnov(v,19).onChange($event.target.value)) !== false);
        ad = (pd_0 && ad);
      }
      if (('blur' === en)) {
        const pd_1:any = ((<any>import1.ɵnov(v,19).onTouched()) !== false);
        ad = (pd_1 && ad);
      }
      if (('ngModelChange' === en)) {
        const pd_2:any = ((<any>(v.context.$implicit.payroll_as = $event)) !== false);
        ad = (pd_2 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import1.ɵdid(16384,(null as any),0,import8.SelectControlValueAccessor,[
      import1.Renderer,
      import1.ElementRef
    ]
    ,(null as any),(null as any)),
    import1.ɵprd(1024,(null as any),import8.NG_VALUE_ACCESSOR,(p0_0:any) => {
      return [p0_0];
    },[import8.SelectControlValueAccessor]),
    import1.ɵdid(671744,(null as any),0,import8.NgModel,[
      [
        2,
        import8.ControlContainer
      ]
      ,
      [
        8,
        (null as any)
      ]
      ,
      [
        8,
        (null as any)
      ]
      ,
      [
        2,
        import8.NG_VALUE_ACCESSOR
      ]

    ]
    ,{
      name: [
        0,
        'name'
      ]
      ,
      isDisabled: [
        1,
        'isDisabled'
      ]
      ,
      model: [
        2,
        'model'
      ]

    }
    ,{update: 'ngModelChange'}),
    import1.ɵprd(2048,(null as any),import8.NgControl,(null as any),[import8.NgModel]),
    import1.ɵdid(16384,(null as any),0,import8.NgControlStatus,[import8.NgControl],(null as any),(null as any)),
    (l()(),import1.ɵted((null as any),['\n                                            '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),3,'option',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    import1.ɵdid(147456,(null as any),0,import8.NgSelectOption,[
      import1.ElementRef,
      import1.Renderer,
      [
        2,
        import8.SelectControlValueAccessor
      ]

    ]
      ,{value: [
        0,
        'value'
      ]
    },(null as any)),
    import1.ɵdid(147456,(null as any),0,import8.ɵq,[
      import1.ElementRef,
      import1.Renderer,
      [
        8,
        (null as any)
      ]

    ]
      ,{value: [
        0,
        'value'
      ]
    },(null as any)),
    (l()(),import1.ɵted((null as any),[
      '',
      '\n                                            '
    ]
    )),
    (l()(),import1.ɵted((null as any),['\n                                        '])),
    (l()(),import1.ɵted((null as any),['\n                                '])),
    (l()(),import1.ɵted((null as any),['\n                                '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),4,'section',[[
        'class',
        'recommended_payroll'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n                                    RECOMMENDED\n                                    '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'span',[
      [
        'class',
        'note note_block note_green recommended_payroll_as'
      ]
      ,
      [
        'id',
        'recommended_payroll_as'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),[
      '',
      ''
    ]
    )),
    (l()(),import1.ɵted((null as any),['\n                                '])),
    (l()(),import1.ɵted((null as any),['\n                                '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),39,'section',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n                                    '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),17,'div',[[
        'class',
        'payroll-card__option'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n                                        '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),14,'md-checkbox',[[
        'class',
        'mat-checkbox'
      ]
    ],[
      [
        2,
        'mat-checkbox-indeterminate',
        (null as any)
      ]
      ,
      [
        2,
        'mat-checkbox-checked',
        (null as any)
      ]
      ,
      [
        2,
        'mat-checkbox-disabled',
        (null as any)
      ]
      ,
      [
        2,
        'mat-checkbox-label-before',
        (null as any)
      ]
      ,
      [
        2,
        'ng-untouched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-touched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pristine',
        (null as any)
      ]
      ,
      [
        2,
        'ng-dirty',
        (null as any)
      ]
      ,
      [
        2,
        'ng-valid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-invalid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pending',
        (null as any)
      ]

    ]
    ,[
      [
        (null as any),
        'ngModelChange'
      ]
      ,
      [
        (null as any),
        'change'
      ]

    ]
    ,(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('ngModelChange' === en)) {
        const pd_0:any = ((<any>(v.context.$implicit.pay_interpreter = $event)) !== false);
        ad = (pd_0 && ad);
      }
      if (('change' === en)) {
        const pd_1:any = ((<any>co.cbChanged('payroll_attributes','pay_interpreter',v.context.index)) !== false);
        ad = (pd_1 && ad);
      }
      return ad;
    },import6.View_MdCheckbox_0,import6.RenderType_MdCheckbox)),
    import1.ɵdid(16384,(null as any),0,import7.MdPrefixRejector,[
      [
        2,
        import7.MATERIAL_COMPATIBILITY_MODE
      ]
      ,
      import1.ElementRef
    ]
    ,(null as any),(null as any)),
    import1.ɵdid(4374528,(null as any),0,import7.MdCheckbox,[
      import1.Renderer2,
      import1.ElementRef,
      import1.ChangeDetectorRef,
      import7.FocusOriginMonitor
    ]
      ,{name: [
        0,
        'name'
      ]
    },{change: 'change'}),
    import1.ɵprd(1024,(null as any),import8.NG_VALUE_ACCESSOR,(p0_0:any) => {
      return [p0_0];
    },[import7.MdCheckbox]),
    import1.ɵdid(671744,(null as any),0,import8.NgModel,[
      [
        2,
        import8.ControlContainer
      ]
      ,
      [
        8,
        (null as any)
      ]
      ,
      [
        8,
        (null as any)
      ]
      ,
      [
        2,
        import8.NG_VALUE_ACCESSOR
      ]

    ]
    ,{
      name: [
        0,
        'name'
      ]
      ,
      model: [
        1,
        'model'
      ]

    }
    ,{update: 'ngModelChange'}),
    import1.ɵprd(2048,(null as any),import8.NgControl,(null as any),[import8.NgModel]),
    import1.ɵdid(16384,(null as any),0,import8.NgControlStatus,[import8.NgControl],(null as any),(null as any)),
      import1.ɵdid(16384,(null as any),0,import9.MdPrefixRejector,[[
        2,
        import9.MATERIAL_COMPATIBILITY_MODE
      ]
    ],(null as any),(null as any)),
    (l()(),import1.ɵted(0,['\n                                            Pay interpreter\n                                            '])),
    (l()(),import1.ɵand(16777216,(null as any),0,1,(null as any),View_BookingPayrollComponent_2)),
    import1.ɵdid(16384,(null as any),0,import10.NgIf,[
      import1.ViewContainerRef,
      import1.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import1.ɵted(0,['\n                                            '])),
    (l()(),import1.ɵand(16777216,(null as any),0,1,(null as any),View_BookingPayrollComponent_3)),
    import1.ɵdid(16384,(null as any),0,import10.NgIf,[
      import1.ViewContainerRef,
      import1.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import1.ɵted(0,['\n                                        '])),
    (l()(),import1.ɵted((null as any),['\n                                    '])),
    (l()(),import1.ɵted((null as any),['\n                                    '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),17,'div',[[
        'class',
        'payroll-card__option payroll-card__option_with-offset'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n                                        '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),14,'md-checkbox',[[
        'class',
        'mat-checkbox'
      ]
    ],[
      [
        2,
        'mat-checkbox-indeterminate',
        (null as any)
      ]
      ,
      [
        2,
        'mat-checkbox-checked',
        (null as any)
      ]
      ,
      [
        2,
        'mat-checkbox-disabled',
        (null as any)
      ]
      ,
      [
        2,
        'mat-checkbox-label-before',
        (null as any)
      ]
      ,
      [
        2,
        'ng-untouched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-touched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pristine',
        (null as any)
      ]
      ,
      [
        2,
        'ng-dirty',
        (null as any)
      ]
      ,
      [
        2,
        'ng-valid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-invalid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pending',
        (null as any)
      ]

    ]
    ,[
      [
        (null as any),
        'ngModelChange'
      ]
      ,
      [
        (null as any),
        'change'
      ]

    ]
    ,(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('ngModelChange' === en)) {
        const pd_0:any = ((<any>(v.context.$implicit.pay_travel = $event)) !== false);
        ad = (pd_0 && ad);
      }
      if (('change' === en)) {
        const pd_1:any = ((<any>co.cbChanged('payroll_attributes','pay_travel',v.context.index)) !== false);
        ad = (pd_1 && ad);
      }
      return ad;
    },import6.View_MdCheckbox_0,import6.RenderType_MdCheckbox)),
    import1.ɵdid(16384,(null as any),0,import7.MdPrefixRejector,[
      [
        2,
        import7.MATERIAL_COMPATIBILITY_MODE
      ]
      ,
      import1.ElementRef
    ]
    ,(null as any),(null as any)),
    import1.ɵdid(4374528,(null as any),0,import7.MdCheckbox,[
      import1.Renderer2,
      import1.ElementRef,
      import1.ChangeDetectorRef,
      import7.FocusOriginMonitor
    ]
    ,{
      disabled: [
        0,
        'disabled'
      ]
      ,
      name: [
        1,
        'name'
      ]

    }
    ,{change: 'change'}),
    import1.ɵprd(1024,(null as any),import8.NG_VALUE_ACCESSOR,(p0_0:any) => {
      return [p0_0];
    },[import7.MdCheckbox]),
    import1.ɵdid(671744,(null as any),0,import8.NgModel,[
      [
        2,
        import8.ControlContainer
      ]
      ,
      [
        8,
        (null as any)
      ]
      ,
      [
        8,
        (null as any)
      ]
      ,
      [
        2,
        import8.NG_VALUE_ACCESSOR
      ]

    ]
    ,{
      name: [
        0,
        'name'
      ]
      ,
      isDisabled: [
        1,
        'isDisabled'
      ]
      ,
      model: [
        2,
        'model'
      ]

    }
    ,{update: 'ngModelChange'}),
    import1.ɵprd(2048,(null as any),import8.NgControl,(null as any),[import8.NgModel]),
    import1.ɵdid(16384,(null as any),0,import8.NgControlStatus,[import8.NgControl],(null as any),(null as any)),
      import1.ɵdid(16384,(null as any),0,import9.MdPrefixRejector,[[
        2,
        import9.MATERIAL_COMPATIBILITY_MODE
      ]
    ],(null as any),(null as any)),
    (l()(),import1.ɵted(0,['\n                                            Pay travel\n                                            '])),
    (l()(),import1.ɵand(16777216,(null as any),0,1,(null as any),View_BookingPayrollComponent_4)),
    import1.ɵdid(16384,(null as any),0,import10.NgIf,[
      import1.ViewContainerRef,
      import1.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import1.ɵted(0,['\n                                            '])),
    (l()(),import1.ɵand(16777216,(null as any),0,1,(null as any),View_BookingPayrollComponent_5)),
    import1.ɵdid(16384,(null as any),0,import10.NgIf,[
      import1.ViewContainerRef,
      import1.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import1.ɵted(0,['\n                                        '])),
    (l()(),import1.ɵted((null as any),['\n                                    '])),
    (l()(),import1.ɵted((null as any),['\n                                '])),
    (l()(),import1.ɵted((null as any),['\n                            '])),
    (l()(),import1.ɵted((null as any),['\n                            '])),
    (l()(),import1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_BookingPayrollComponent_6)),
    import1.ɵdid(16384,(null as any),0,import10.NgIf,[
      import1.ViewContainerRef,
      import1.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import1.ɵted((null as any),['\n                            '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'app-payroll-time',([] as any[]),(null as any),(null as any),(null as any),import11.View_PayrollTimeComponent_0,import11.RenderType_PayrollTimeComponent)),
    import1.ɵdid(4308992,(null as any),0,import12.PayrollTimeComponent,([] as any[]),{
      payrollInvoice: [
        0,
        'payrollInvoice'
      ]
      ,
      index: [
        1,
        'index'
      ]
      ,
      parentForm: [
        2,
        'parentForm'
      ]
      ,
      isReadOnly: [
        3,
        'isReadOnly'
      ]

    }
    ,(null as any)),
    (l()(),import1.ɵted((null as any),['\n                            '])),
    (l()(),import1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_BookingPayrollComponent_7)),
    import1.ɵdid(16384,(null as any),0,import10.NgIf,[
      import1.ViewContainerRef,
      import1.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import1.ɵted((null as any),['\n                        '])),
    (l()(),import1.ɵted((null as any),['\n                        '])),
    (l()(),import1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_BookingPayrollComponent_8)),
    import1.ɵdid(16384,(null as any),0,import10.NgIf,[
      import1.ViewContainerRef,
      import1.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import1.ɵted((null as any),['\n                    ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_10:any = import1.ɵinlineInterpolate(1,'',('payrollAs_' + v.context.index),'');
    const currVal_11:any = '';
    const currVal_12:any = v.context.$implicit.payroll_as;
    ck(v,21,0,currVal_10,currVal_11,currVal_12);
    const currVal_13:any = v.context.$implicit.payroll_as;
    ck(v,26,0,currVal_13);
    const currVal_14:any = v.context.$implicit.payroll_as;
    ck(v,27,0,currVal_14);
    const currVal_28:any = import1.ɵinlineInterpolate(1,'',('cbPayInterpreter_' + v.context.index),'');
    ck(v,44,0,currVal_28);
    const currVal_29:any = import1.ɵinlineInterpolate(1,'',('cbPayInterpreter_' + v.context.index),'');
    const currVal_30:any = v.context.$implicit.pay_interpreter;
    ck(v,46,0,currVal_29,currVal_30);
    const currVal_31:any = v.context.$implicit.recommended.pay_interpreter;
    ck(v,52,0,currVal_31);
    const currVal_32:boolean = !v.context.$implicit.recommended.pay_interpreter;
    ck(v,55,0,currVal_32);
    const currVal_44:boolean = !v.context.$implicit.pay_interpreter;
    const currVal_45:any = import1.ɵinlineInterpolate(1,'',('cbPayTravel_' + v.context.index),'');
    ck(v,63,0,currVal_44,currVal_45);
    const currVal_46:any = import1.ɵinlineInterpolate(1,'',('cbPayTravel_' + v.context.index),'');
    const currVal_47:boolean = !v.context.$implicit.pay_interpreter;
    const currVal_48:any = v.context.$implicit.pay_travel;
    ck(v,65,0,currVal_46,currVal_47,currVal_48);
    const currVal_49:any = v.context.$implicit.recommended.pay_travel;
    ck(v,71,0,currVal_49);
    const currVal_50:boolean = !v.context.$implicit.recommended.pay_travel;
    ck(v,74,0,currVal_50);
    const currVal_51:any = co.isDSQ;
    ck(v,81,0,currVal_51);
    const currVal_52:any = v.context.$implicit;
    const currVal_53:any = v.context.index;
    const currVal_54:any = import1.ɵnov((<any>v.parent),13);
    const currVal_55:boolean = !v.context.$implicit.pay_interpreter;
    ck(v,84,0,currVal_52,currVal_53,currVal_54,currVal_55);
    const currVal_56:any = co.isDSQ;
    ck(v,87,0,currVal_56);
    const currVal_57:any = co.payments.invoice_attributes;
    ck(v,91,0,currVal_57);
  },(ck,v) => {
    const currVal_0:any = (v.context.index + 1);
    const currVal_1:any = ((v.context.$implicit.interpreter_first_name + ' ') + v.context.$implicit.interpreter_last_name);
    ck(v,5,0,currVal_0,currVal_1);
    const currVal_2:any = v.context.$implicit.id;
    ck(v,9,0,currVal_2);
    const currVal_3:any = import1.ɵnov(v,23).ngClassUntouched;
    const currVal_4:any = import1.ɵnov(v,23).ngClassTouched;
    const currVal_5:any = import1.ɵnov(v,23).ngClassPristine;
    const currVal_6:any = import1.ɵnov(v,23).ngClassDirty;
    const currVal_7:any = import1.ɵnov(v,23).ngClassValid;
    const currVal_8:any = import1.ɵnov(v,23).ngClassInvalid;
    const currVal_9:any = import1.ɵnov(v,23).ngClassPending;
    ck(v,18,0,currVal_3,currVal_4,currVal_5,currVal_6,currVal_7,currVal_8,currVal_9);
    const currVal_15:any = v.context.$implicit.payroll_as.toUpperCase();
    ck(v,28,0,currVal_15);
    const currVal_16:any = v.context.$implicit.recommended.payroll_as.toUpperCase();
    ck(v,35,0,currVal_16);
    const currVal_17:any = import1.ɵnov(v,44).indeterminate;
    const currVal_18:any = import1.ɵnov(v,44).checked;
    const currVal_19:any = import1.ɵnov(v,44).disabled;
    const currVal_20:any = (import1.ɵnov(v,44).labelPosition == 'before');
    const currVal_21:any = import1.ɵnov(v,48).ngClassUntouched;
    const currVal_22:any = import1.ɵnov(v,48).ngClassTouched;
    const currVal_23:any = import1.ɵnov(v,48).ngClassPristine;
    const currVal_24:any = import1.ɵnov(v,48).ngClassDirty;
    const currVal_25:any = import1.ɵnov(v,48).ngClassValid;
    const currVal_26:any = import1.ɵnov(v,48).ngClassInvalid;
    const currVal_27:any = import1.ɵnov(v,48).ngClassPending;
    ck(v,42,1,[
      currVal_17,
      currVal_18,
      currVal_19,
      currVal_20,
      currVal_21,
      currVal_22,
      currVal_23,
      currVal_24,
      currVal_25,
      currVal_26,
      currVal_27
    ]
    );
    const currVal_33:any = import1.ɵnov(v,63).indeterminate;
    const currVal_34:any = import1.ɵnov(v,63).checked;
    const currVal_35:any = import1.ɵnov(v,63).disabled;
    const currVal_36:any = (import1.ɵnov(v,63).labelPosition == 'before');
    const currVal_37:any = import1.ɵnov(v,67).ngClassUntouched;
    const currVal_38:any = import1.ɵnov(v,67).ngClassTouched;
    const currVal_39:any = import1.ɵnov(v,67).ngClassPristine;
    const currVal_40:any = import1.ɵnov(v,67).ngClassDirty;
    const currVal_41:any = import1.ɵnov(v,67).ngClassValid;
    const currVal_42:any = import1.ɵnov(v,67).ngClassInvalid;
    const currVal_43:any = import1.ɵnov(v,67).ngClassPending;
    ck(v,61,1,[
      currVal_33,
      currVal_34,
      currVal_35,
      currVal_36,
      currVal_37,
      currVal_38,
      currVal_39,
      currVal_40,
      currVal_41,
      currVal_42,
      currVal_43
    ]
    );
  });
}
function View_BookingPayrollComponent_15(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
      (l()(),import1.ɵeld(0,[[
        'emptyPayrollContainer',
        1
      ]
      ],(null as any),7,'section',[[
        'class',
        'payroll-card'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n                        '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),4,'section',[[
        'class',
        'payroll-card__interpreter'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n                            '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),1,'header',[[
        'class',
        'payroll-card__header'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['No Interpreters were allocated to this booking'])),
    (l()(),import1.ɵted((null as any),['\n                        '])),
    (l()(),import1.ɵted((null as any),['\n                    ']))
  ]
  ,(null as any),(null as any));
}
function View_BookingPayrollComponent_16(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
    (l()(),import1.ɵeld(0,(null as any),(null as any),18,(null as any),(null as any),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n                        '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),15,'div',[[
        'class',
        'medium-12'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n                            '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),12,'div',[[
        'class',
        'form-field'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n                                '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'h2',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['CLAIM NOTES'])),
    (l()(),import1.ɵted((null as any),['\n                                '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),6,'textarea',[
      [
        'class',
        'inline-icon inline-icon-txt'
      ]
      ,
      [
        'cols',
        '30'
      ]
      ,
      [
        'name',
        'claim_notes'
      ]
      ,
      [
        'rows',
        '10'
      ]
      ,
      [
        'type',
        'text'
      ]

    ]
    ,[
      [
        2,
        'ng-untouched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-touched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pristine',
        (null as any)
      ]
      ,
      [
        2,
        'ng-dirty',
        (null as any)
      ]
      ,
      [
        2,
        'ng-valid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-invalid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pending',
        (null as any)
      ]

    ]
    ,[
      [
        (null as any),
        'ngModelChange'
      ]
      ,
      [
        (null as any),
        'input'
      ]
      ,
      [
        (null as any),
        'blur'
      ]
      ,
      [
        (null as any),
        'compositionstart'
      ]
      ,
      [
        (null as any),
        'compositionend'
      ]

    ]
    ,(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('input' === en)) {
        const pd_0:any = ((<any>import1.ɵnov(v,10)._handleInput($event.target.value)) !== false);
        ad = (pd_0 && ad);
      }
      if (('blur' === en)) {
        const pd_1:any = ((<any>import1.ɵnov(v,10).onTouched()) !== false);
        ad = (pd_1 && ad);
      }
      if (('compositionstart' === en)) {
        const pd_2:any = ((<any>import1.ɵnov(v,10)._compositionStart()) !== false);
        ad = (pd_2 && ad);
      }
      if (('compositionend' === en)) {
        const pd_3:any = ((<any>import1.ɵnov(v,10)._compositionEnd($event.target.value)) !== false);
        ad = (pd_3 && ad);
      }
      if (('ngModelChange' === en)) {
        const pd_4:any = ((<any>(co.bookingModel.claim_notes = $event)) !== false);
        ad = (pd_4 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import1.ɵdid(16384,(null as any),0,import8.DefaultValueAccessor,[
      import1.Renderer,
      import1.ElementRef,
      [
        2,
        import8.COMPOSITION_BUFFER_MODE
      ]

    ]
    ,(null as any),(null as any)),
    import1.ɵprd(1024,(null as any),import8.NG_VALUE_ACCESSOR,(p0_0:any) => {
      return [p0_0];
    },[import8.DefaultValueAccessor]),
    import1.ɵdid(671744,(null as any),0,import8.NgModel,[
      [
        2,
        import8.ControlContainer
      ]
      ,
      [
        8,
        (null as any)
      ]
      ,
      [
        8,
        (null as any)
      ]
      ,
      [
        2,
        import8.NG_VALUE_ACCESSOR
      ]

    ]
    ,{
      name: [
        0,
        'name'
      ]
      ,
      model: [
        1,
        'model'
      ]

    }
    ,{update: 'ngModelChange'}),
    import1.ɵprd(2048,(null as any),import8.NgControl,(null as any),[import8.NgModel]),
    import1.ɵdid(16384,(null as any),0,import8.NgControlStatus,[import8.NgControl],(null as any),(null as any)),
    (l()(),import1.ɵted((null as any),['                                '])),
    (l()(),import1.ɵted((null as any),['\n                            '])),
    (l()(),import1.ɵted((null as any),['\n                        '])),
    (l()(),import1.ɵted((null as any),['\n                    ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_7:any = 'claim_notes';
    const currVal_8:any = co.bookingModel.claim_notes;
    ck(v,12,0,currVal_7,currVal_8);
  },(ck,v) => {
    const currVal_0:any = import1.ɵnov(v,14).ngClassUntouched;
    const currVal_1:any = import1.ɵnov(v,14).ngClassTouched;
    const currVal_2:any = import1.ɵnov(v,14).ngClassPristine;
    const currVal_3:any = import1.ɵnov(v,14).ngClassDirty;
    const currVal_4:any = import1.ɵnov(v,14).ngClassValid;
    const currVal_5:any = import1.ɵnov(v,14).ngClassInvalid;
    const currVal_6:any = import1.ɵnov(v,14).ngClassPending;
    ck(v,9,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6);
  });
}
function View_BookingPayrollComponent_17(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
      (l()(),import1.ɵeld(0,(null as any),(null as any),4,'div',[[
        'class',
        'actions'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n                    '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),1,'button',[[
        'name',
        'btnSave'
      ]
      ],(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.updatePayment(import1.ɵnov((<any>v.parent),13))) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),[
      '\n                        ',
      ''
    ]
    )),
    (l()(),import1.ɵted((null as any),['\n                ']))
  ]
  ,(null as any),(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = ((co.isDSQ && co.isStateCompleteOrCancelCharge())? 'Claim & Save': 'Save');
    ck(v,3,0,currVal_0);
  });
}
function View_BookingPayrollComponent_20(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
      (l()(),import1.ɵeld(0,(null as any),(null as any),1,'span',[[
        'style',
        'font-style: oblique; font-weight: bolder'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),[
      '',
      ' ID: ',
      ''
    ]
    ))
  ]
  ,(null as any),(ck,v) => {
    const currVal_0:any = (<any>v.parent).context.$implicit.model;
    const currVal_1:any = (<any>v.parent).context.$implicit.object_id;
    ck(v,1,0,currVal_0,currVal_1);
  });
}
function View_BookingPayrollComponent_21(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
      (l()(),import1.ɵeld(0,(null as any),(null as any),1,'span',[[
        'style',
        'font-style: oblique; font-weight: bolder'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),[
      '',
      ' ID: ',
      ''
    ]
    ))
  ]
  ,(null as any),(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = (<any>v.parent).context.$implicit.model;
    const currVal_1:any = co.bookingModel.id;
    ck(v,1,0,currVal_0,currVal_1);
  });
}
function View_BookingPayrollComponent_22(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
    (l()(),import1.ɵeld(0,(null as any),(null as any),10,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n                                            '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'b',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),[
      '',
      ': '
    ]
    )),
    (l()(),import1.ɵted((null as any),[
      '',
      '\n                                            '
    ]
    )),
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'b',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['to'])),
    (l()(),import1.ɵted((null as any),['\n                                            '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'span',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),[
      '',
      ''
    ]
    )),
    (l()(),import1.ɵted((null as any),['\n                                        ']))
  ]
  ,(null as any),(ck,v) => {
    const currVal_0:any = v.context.$implicit[0];
    ck(v,3,0,currVal_0);
    const currVal_1:any = v.context.$implicit[1][0];
    ck(v,4,0,currVal_1);
    const currVal_2:any = v.context.$implicit[1][1];
    ck(v,9,0,currVal_2);
  });
}
function View_BookingPayrollComponent_19(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
    (l()(),import1.ɵeld(0,(null as any),(null as any),34,'tr',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n                                '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),3,'td',[[
        'name',
        'data_created_at'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),[
      '\n                                    ',
      ' on\n                                    ',
      '\n                                '
    ]
    )),
    import1.ɵppd(2),
    import1.ɵppd(3),
    (l()(),import1.ɵted((null as any),['\n                                '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),8,'td',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n                                    '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),0,'img',[
      [
        'alt',
        ''
      ]
      ,
      [
        'height',
        '30px'
      ]
      ,
      [
        'src',
        ''
      ]
      ,
      [
        'width',
        '30px'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n                                    '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),3,'span',[
      [
        'class',
        'display-flx'
      ]
      ,
      [
        'name',
        'data_action'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),[
      '\n                                        ',
      '\n                                        '
    ]
    )),
    (l()(),import1.ɵeld(0,(null as any),(null as any),0,'br',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),[
      ' ',
      '\n                                    '
    ]
    )),
    (l()(),import1.ɵted((null as any),['\n                                '])),
    (l()(),import1.ɵted((null as any),['\n                                '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),16,'td',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n                                    '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),13,'div',[[
        'name',
        'data_changes'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n                                        '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),7,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n                                            '])),
    (l()(),import1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_BookingPayrollComponent_20)),
    import1.ɵdid(16384,(null as any),0,import10.NgIf,[
      import1.ViewContainerRef,
      import1.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import1.ɵted((null as any),['\n                                            '])),
    (l()(),import1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_BookingPayrollComponent_21)),
    import1.ɵdid(16384,(null as any),0,import10.NgIf,[
      import1.ViewContainerRef,
      import1.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import1.ɵted((null as any),['\n                                        '])),
    (l()(),import1.ɵted((null as any),['\n                                        '])),
    (l()(),import1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_BookingPayrollComponent_22)),
    import1.ɵdid(802816,(null as any),0,import10.NgForOf,[
      import1.ViewContainerRef,
      import1.TemplateRef,
      import1.IterableDiffers
    ]
      ,{ngForOf: [
        0,
        'ngForOf'
      ]
    },(null as any)),
    (l()(),import1.ɵted((null as any),['\n                                    '])),
    (l()(),import1.ɵted((null as any),['\n                                '])),
    (l()(),import1.ɵted((null as any),['\n                            ']))
  ]
  ,(ck,v) => {
    const currVal_4:any = (v.context.$implicit.model !== 'Booking');
    ck(v,24,0,currVal_4);
    const currVal_5:any = (v.context.$implicit.model === 'Booking');
    ck(v,27,0,currVal_5);
    const currVal_6:any = v.context.$implicit.change_set_formatted_hash();
    ck(v,31,0,currVal_6);
  },(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = import1.ɵunv(v,3,0,ck(v,4,0,import1.ɵnov((<any>(<any>v.parent).parent),0),v.context.$implicit.created_at_iso,'shortTime'));
    const currVal_1:any = import1.ɵunv(v,3,1,ck(v,5,0,import1.ɵnov((<any>(<any>v.parent).parent),1),v.context.$implicit.created_at_iso,co.bookingModel.venue.state,co.bookingModel.venue.post_code));
    ck(v,3,0,currVal_0,currVal_1);
    const currVal_2:any = v.context.$implicit.booking_event_formatted();
    ck(v,12,0,currVal_2);
    const currVal_3:any = v.context.$implicit.full_name();
    ck(v,14,0,currVal_3);
  });
}
function View_BookingPayrollComponent_18(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
    (l()(),import1.ɵeld(0,(null as any),(null as any),25,(null as any),(null as any),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n                    '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'h2',[
      [
        'class',
        'hidden-mobile'
      ]
      ,
      [
        'name',
        'payment-history'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['Payroll History'])),
    (l()(),import1.ɵted((null as any),['\n                    '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),19,'table',[
      [
        'class',
        'custom-small-table'
      ]
      ,
      [
        'id',
        'changes-history'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n                        '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),10,'thead',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n                            '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),1,'th',[[
        'width',
        '20%'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['Date and Time'])),
    (l()(),import1.ɵted((null as any),['\n                            '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),1,'th',[[
        'width',
        '30%'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['Action'])),
    (l()(),import1.ɵted((null as any),['\n                            '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'th',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['Changes'])),
    (l()(),import1.ɵted((null as any),['\n                        '])),
    (l()(),import1.ɵted((null as any),['\n                        '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),4,'tbody',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n                            '])),
    (l()(),import1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_BookingPayrollComponent_19)),
    import1.ɵdid(802816,(null as any),0,import10.NgForOf,[
      import1.ViewContainerRef,
      import1.TemplateRef,
      import1.IterableDiffers
    ]
      ,{ngForOf: [
        0,
        'ngForOf'
      ]
    },(null as any)),
    (l()(),import1.ɵted((null as any),['\n                        '])),
    (l()(),import1.ɵted((null as any),['\n                    '])),
    (l()(),import1.ɵted((null as any),['\n                ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.payments.versions;
    ck(v,22,0,currVal_0);
  },(null as any));
}
export function View_BookingPayrollComponent_0(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
    import1.ɵpid(0,import10.DatePipe,[import1.LOCALE_ID]),
    import1.ɵpid(0,import13.MomentTZDatePipe,([] as any[])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),46,'section',[[
        'id',
        'page-common'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n    '])),
    (l()(),import1.ɵeld(16777216,(null as any),(null as any),1,'app-booking-header',([] as any[]),(null as any),(null as any),(null as any),import14.View_BookingHeaderComponent_0,import14.RenderType_BookingHeaderComponent)),
    import1.ɵdid(245760,(null as any),0,import15.BookingHeaderComponent,[
      import1.NgZone,
      import16.BookingHeaderService,
      import17.Router,
      import7.MdDialog,
      import1.ViewContainerRef,
      import18.NotificationServiceBus
    ]
    ,{
      bookingModel: [
        0,
        'bookingModel'
      ]
      ,
      paymentModel: [
        1,
        'paymentModel'
      ]
      ,
      oldModel: [
        2,
        'oldModel'
      ]
      ,
      showButtons: [
        3,
        'showButtons'
      ]

    }
    ,(null as any)),
    (l()(),import1.ɵted((null as any),['\n    '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),40,'section',[[
        'id',
        'job-booking'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n        '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),37,'main',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n            '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),34,'form',[
      [
        'class',
        'common-form reduced-top'
      ]
      ,
      [
        'novalidate',
        ''
      ]

    ]
    ,[
      [
        2,
        'ng-untouched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-touched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pristine',
        (null as any)
      ]
      ,
      [
        2,
        'ng-dirty',
        (null as any)
      ]
      ,
      [
        2,
        'ng-valid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-invalid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pending',
        (null as any)
      ]

    ]
    ,[
      [
        (null as any),
        'submit'
      ]
      ,
      [
        (null as any),
        'reset'
      ]

    ]
    ,(v,en,$event) => {
      var ad:boolean = true;
      if (('submit' === en)) {
        const pd_0:any = ((<any>import1.ɵnov(v,13).onSubmit($event)) !== false);
        ad = (pd_0 && ad);
      }
      if (('reset' === en)) {
        const pd_1:any = ((<any>import1.ɵnov(v,13).onReset()) !== false);
        ad = (pd_1 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import1.ɵdid(16384,(null as any),0,import8.ɵbf,([] as any[]),(null as any),(null as any)),
      import1.ɵdid(16384,[[
        'payroll_form',
        4
      ]
    ],0,import8.NgForm,[
      [
        8,
        (null as any)
      ]
      ,
      [
        8,
        (null as any)
      ]

    ]
    ,(null as any),(null as any)),
    import1.ɵprd(2048,(null as any),import8.ControlContainer,(null as any),[import8.NgForm]),
    import1.ɵdid(16384,(null as any),0,import8.NgControlStatusGroup,[import8.ControlContainer],(null as any),(null as any)),
    (l()(),import1.ɵted((null as any),['\n                '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'app-booking-info',([] as any[]),(null as any),(null as any),(null as any),import19.View_BookingInfoComponent_0,import19.RenderType_BookingInfoComponent)),
      import1.ɵdid(49152,(null as any),0,import20.BookingInfoComponent,([] as any[]),{selectedBookingModel: [
        0,
        'selectedBookingModel'
      ]
    },(null as any)),
    (l()(),import1.ɵted((null as any),['\n\n                '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'h2',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['Payroll Details'])),
    (l()(),import1.ɵted((null as any),['\n                '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),9,'fieldset',[[
        'name',
        'bookingPayrollFieldset'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n                    '])),
    (l()(),import1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_BookingPayrollComponent_1)),
    import1.ɵdid(802816,(null as any),0,import10.NgForOf,[
      import1.ViewContainerRef,
      import1.TemplateRef,
      import1.IterableDiffers
    ]
      ,{ngForOf: [
        0,
        'ngForOf'
      ]
    },(null as any)),
    (l()(),import1.ɵted((null as any),['\n                    '])),
    (l()(),import1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_BookingPayrollComponent_15)),
    import1.ɵdid(16384,(null as any),0,import10.NgIf,[
      import1.ViewContainerRef,
      import1.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import1.ɵted((null as any),['\n                    '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),0,'br',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n                '])),
    (l()(),import1.ɵted((null as any),['\n                '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),4,'fieldset',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n                    '])),
    (l()(),import1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_BookingPayrollComponent_16)),
    import1.ɵdid(16384,(null as any),0,import10.NgIf,[
      import1.ViewContainerRef,
      import1.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import1.ɵted((null as any),['\n                '])),
    (l()(),import1.ɵted((null as any),['\n                '])),
    (l()(),import1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_BookingPayrollComponent_17)),
    import1.ɵdid(16384,(null as any),0,import10.NgIf,[
      import1.ViewContainerRef,
      import1.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import1.ɵted((null as any),['\n                '])),
    (l()(),import1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_BookingPayrollComponent_18)),
    import1.ɵdid(16384,(null as any),0,import10.NgIf,[
      import1.ViewContainerRef,
      import1.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import1.ɵted((null as any),['\n            '])),
    (l()(),import1.ɵted((null as any),['\n        '])),
    (l()(),import1.ɵted((null as any),['\n    '])),
    (l()(),import1.ɵted((null as any),['\n'])),
    (l()(),import1.ɵted((null as any),['\n']))
  ]
  ,(ck,v) => {
    var co:import21.BookingPayrollComponent = v.component;
    const currVal_0:any = co.bookingModel;
    const currVal_1:any = co.payments;
    const currVal_2:any = co.oldPayments;
    const currVal_3:any = false;
    ck(v,5,0,currVal_0,currVal_1,currVal_2,currVal_3);
    const currVal_11:any = co.bookingModel;
    ck(v,18,0,currVal_11);
    const currVal_12:any = co.payments.payroll_attributes;
    ck(v,26,0,currVal_12);
    const currVal_13:boolean = !co.payments.payroll_attributes.length;
    ck(v,29,0,currVal_13);
    const currVal_14:any = (co.isCurrentUserAdmin() || co.isCurrentUserBO());
    ck(v,37,0,currVal_14);
    const currVal_15:any = (co.payments.payroll_attributes.length > 0);
    ck(v,41,0,currVal_15);
    const currVal_16:any = (co.isCurrentUserAdmin() || co.isCurrentUserBO());
    ck(v,44,0,currVal_16);
  },(ck,v) => {
    const currVal_4:any = import1.ɵnov(v,15).ngClassUntouched;
    const currVal_5:any = import1.ɵnov(v,15).ngClassTouched;
    const currVal_6:any = import1.ɵnov(v,15).ngClassPristine;
    const currVal_7:any = import1.ɵnov(v,15).ngClassDirty;
    const currVal_8:any = import1.ɵnov(v,15).ngClassValid;
    const currVal_9:any = import1.ɵnov(v,15).ngClassInvalid;
    const currVal_10:any = import1.ɵnov(v,15).ngClassPending;
    ck(v,11,0,currVal_4,currVal_5,currVal_6,currVal_7,currVal_8,currVal_9,currVal_10);
  });
}
function View_BookingPayrollComponent_Host_0(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'app-booking-payroll',([] as any[]),(null as any),(null as any),(null as any),View_BookingPayrollComponent_0,RenderType_BookingPayrollComponent)),
    import1.ɵdid(245760,(null as any),0,import21.BookingPayrollComponent,[
      import22.SpinnerService,
      import23.BookingService,
      import17.ActivatedRoute,
      import18.NotificationServiceBus
    ]
    ,(null as any),(null as any))
  ]
  ,(ck,v) => {
    ck(v,1,0);
  },(null as any));
}
export const BookingPayrollComponentNgFactory:import1.ComponentFactory<import21.BookingPayrollComponent> = import1.ɵccf('app-booking-payroll',import21.BookingPayrollComponent,View_BookingPayrollComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3ZlcmNlbC93b3JrcGF0aDAvc3JjL2FwcC9ib29raW5nLW1hbmFnZW1lbnQvYm9va2luZy1wYXlyb2xsL2Jvb2tpbmctcGF5cm9sbC5jb21wb25lbnQubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vdmVyY2VsL3dvcmtwYXRoMC9zcmMvYXBwL2Jvb2tpbmctbWFuYWdlbWVudC9ib29raW5nLXBheXJvbGwvYm9va2luZy1wYXlyb2xsLmNvbXBvbmVudC50cyIsIm5nOi8vL3ZlcmNlbC93b3JrcGF0aDAvc3JjL2FwcC9ib29raW5nLW1hbmFnZW1lbnQvYm9va2luZy1wYXlyb2xsL2Jvb2tpbmctcGF5cm9sbC5jb21wb25lbnQuaHRtbCIsIm5nOi8vL3ZlcmNlbC93b3JrcGF0aDAvc3JjL2FwcC9ib29raW5nLW1hbmFnZW1lbnQvYm9va2luZy1wYXlyb2xsL2Jvb2tpbmctcGF5cm9sbC5jb21wb25lbnQudHMuQm9va2luZ1BheXJvbGxDb21wb25lbnRfSG9zdC5odG1sIl0sInNvdXJjZXNDb250ZW50IjpbIiAiLCI8c2VjdGlvbiBpZD1cInBhZ2UtY29tbW9uXCI+XG4gICAgPGFwcC1ib29raW5nLWhlYWRlciBbc2hvd0J1dHRvbnNdPSdmYWxzZScgW2Jvb2tpbmdNb2RlbF09J2Jvb2tpbmdNb2RlbCcgW29sZE1vZGVsXT0nb2xkUGF5bWVudHMnXG4gICAgICAgICAgICAgICAgICAgICAgICBbcGF5bWVudE1vZGVsXT0ncGF5bWVudHMnPjwvYXBwLWJvb2tpbmctaGVhZGVyPlxuICAgIDxzZWN0aW9uIGlkPVwiam9iLWJvb2tpbmdcIj5cbiAgICAgICAgPG1haW4+XG4gICAgICAgICAgICA8Zm9ybSAjcGF5cm9sbF9mb3JtPVwibmdGb3JtXCIgY2xhc3M9XCJjb21tb24tZm9ybSByZWR1Y2VkLXRvcFwiPlxuICAgICAgICAgICAgICAgIDxhcHAtYm9va2luZy1pbmZvIFtzZWxlY3RlZEJvb2tpbmdNb2RlbF09XCJib29raW5nTW9kZWxcIj48L2FwcC1ib29raW5nLWluZm8+XG5cbiAgICAgICAgICAgICAgICA8aDI+UGF5cm9sbCBEZXRhaWxzPC9oMj5cbiAgICAgICAgICAgICAgICA8ZmllbGRzZXQgbmFtZT1cImJvb2tpbmdQYXlyb2xsRmllbGRzZXRcIj5cbiAgICAgICAgICAgICAgICAgICAgPHNlY3Rpb24gKm5nRm9yPVwibGV0IHBheXJvbGwgb2YgcGF5bWVudHMucGF5cm9sbF9hdHRyaWJ1dGVzOyBsZXQgaSA9IGluZGV4XCIgY2xhc3M9XCJwYXlyb2xsLWNhcmRcIj5cbiAgICAgICAgICAgICAgICAgICAgICAgIDxzZWN0aW9uIGNsYXNzPVwicGF5cm9sbC1jYXJkX19pbnRlcnByZXRlclwiPlxuICAgICAgICAgICAgICAgICAgICAgICAgICAgIDxoZWFkZXIgY2xhc3M9XCJwYXlyb2xsLWNhcmRfX2hlYWRlclwiPkludGVycHJldGVyIHt7aSsxfX06IHt7cGF5cm9sbC5pbnRlcnByZXRlcl9maXJzdF9uYW1lXG4gICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICsnICcrcGF5cm9sbC5pbnRlcnByZXRlcl9sYXN0X25hbWV9fTxici8+XG4gICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIDxzcGFuIGNsYXNzPVwicGF5cm9sbF9pZFwiPklEOiB7e3BheXJvbGwuaWR9fTwvc3Bhbj5cbiAgICAgICAgICAgICAgICAgICAgICAgICAgICA8L2hlYWRlcj5cbiAgICAgICAgICAgICAgICAgICAgICAgICAgICA8c2VjdGlvbiBjbGFzcz1cInBheXJvbGwtY2FyZF9fY29udGVudFwiPlxuICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICA8c2VjdGlvbiBjbGFzcz1cImNvbW1vbi1mb3JtXCI+XG4gICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICBQQVlST0xMIEFTXG4gICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICA8ZGl2IGNsYXNzPVwiZm9ybS1maWVsZFwiPlxuICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIDxzZWxlY3QgbmFtZT1cInt7J3BheXJvbGxBc18nICsgaX19XCIgWyhuZ01vZGVsKV09XCJwYXlyb2xsLnBheXJvbGxfYXNcIlxuICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgY2xhc3M9XCJtZW51IGN1c3RvbSBncmF5XCIgZGlzYWJsZWQ+XG4gICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIDxvcHRpb24gW3ZhbHVlXT1cInBheXJvbGwucGF5cm9sbF9hc1wiPnt7cGF5cm9sbC5wYXlyb2xsX2FzLnRvVXBwZXJDYXNlKCl9fVxuICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICA8L29wdGlvbj5cbiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICA8L3NlbGVjdD48L2Rpdj5cbiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgPC9zZWN0aW9uPlxuICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICA8c2VjdGlvbiBjbGFzcz1cInJlY29tbWVuZGVkX3BheXJvbGxcIj5cbiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIFJFQ09NTUVOREVEXG4gICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICA8c3BhbiBjbGFzcz1cIm5vdGUgbm90ZV9ibG9jayBub3RlX2dyZWVuIHJlY29tbWVuZGVkX3BheXJvbGxfYXNcIlxuICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgaWQ9XCJyZWNvbW1lbmRlZF9wYXlyb2xsX2FzXCI+e3twYXlyb2xsLnJlY29tbWVuZGVkLnBheXJvbGxfYXMudG9VcHBlckNhc2UoKX19PC9zcGFuPlxuICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICA8L3NlY3Rpb24+XG4gICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIDxzZWN0aW9uPlxuICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgPGRpdiBjbGFzcz1cInBheXJvbGwtY2FyZF9fb3B0aW9uXCI+XG4gICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgPG1kLWNoZWNrYm94IG5hbWU9XCJ7eydjYlBheUludGVycHJldGVyXycgKyBpfX1cIlxuICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICBbKG5nTW9kZWwpXT1cInBheXJvbGwucGF5X2ludGVycHJldGVyXCJcbiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgKGNoYW5nZSk9XCJjYkNoYW5nZWQoJ3BheXJvbGxfYXR0cmlidXRlcycsJ3BheV9pbnRlcnByZXRlcicsaSlcIj5cbiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgUGF5IGludGVycHJldGVyXG4gICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIDxzcGFuIGNsYXNzPVwibm90ZSBub3RlX2Jsb2NrIG5vdGVfZ3JlZW4gbm90ZV9zbWFsbFwiICpuZ0lmPVwicGF5cm9sbC5yZWNvbW1lbmRlZC5wYXlfaW50ZXJwcmV0ZXJcIj5SRUNPTU1FTkRFRDwvc3Bhbj5cbiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgPHNwYW4gY2xhc3M9XCJub3RlIG5vdGVfYmxvY2sgbm90ZV9zbWFsbFwiICpuZ0lmPVwiIXBheXJvbGwucmVjb21tZW5kZWQucGF5X2ludGVycHJldGVyXCI+Tk9UIFJFQ09NTUVOREVEPC9zcGFuPlxuICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIDwvbWQtY2hlY2tib3g+XG4gICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICA8L2Rpdj5cbiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIDxkaXYgY2xhc3M9XCJwYXlyb2xsLWNhcmRfX29wdGlvbiBwYXlyb2xsLWNhcmRfX29wdGlvbl93aXRoLW9mZnNldFwiPlxuICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIDxtZC1jaGVja2JveCBuYW1lPVwie3snY2JQYXlUcmF2ZWxfJyArIGl9fVwiIFsobmdNb2RlbCldPVwicGF5cm9sbC5wYXlfdHJhdmVsXCJcbiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgW2Rpc2FibGVkXT1cIiFwYXlyb2xsLnBheV9pbnRlcnByZXRlclwiXG4gICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIChjaGFuZ2UpPVwiY2JDaGFuZ2VkKCdwYXlyb2xsX2F0dHJpYnV0ZXMnLCdwYXlfdHJhdmVsJyxpKVwiPlxuICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICBQYXkgdHJhdmVsXG4gICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIDxzcGFuIGNsYXNzPVwibm90ZSBub3RlX2Jsb2NrIG5vdGVfZ3JlZW4gbm90ZV9zbWFsbFwiICpuZ0lmPVwicGF5cm9sbC5yZWNvbW1lbmRlZC5wYXlfdHJhdmVsXCI+UkVDT01NRU5ERUQ8L3NwYW4+XG4gICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIDxzcGFuIGNsYXNzPVwibm90ZSBub3RlX2Jsb2NrIG5vdGVfc21hbGxcIiAqbmdJZj1cIiFwYXlyb2xsLnJlY29tbWVuZGVkLnBheV90cmF2ZWxcIj5OT1QgUkVDT01NRU5ERUQ8L3NwYW4+XG4gICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgPC9tZC1jaGVja2JveD5cbiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIDwvZGl2PlxuICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICA8L3NlY3Rpb24+XG4gICAgICAgICAgICAgICAgICAgICAgICAgICAgPC9zZWN0aW9uPlxuICAgICAgICAgICAgICAgICAgICAgICAgICAgIDxhcHAtcGF5cm9sbC1hZGRpdGlvbmFsLWNvc3RzIFtwYXlyb2xsSW52b2ljZV09XCJwYXlyb2xsXCIgW2luZGV4XT1cImlcIiBbcGFyZW50Rm9ybV09XCJwYXlyb2xsX2Zvcm1cIlxuICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAqbmdJZj0naXNEU1EnICAgICBbaXNSZWFkT25seV09XCIhcGF5cm9sbC5wYXlfaW50ZXJwcmV0ZXJcIj48L2FwcC1wYXlyb2xsLWFkZGl0aW9uYWwtY29zdHM+XG4gICAgICAgICAgICAgICAgICAgICAgICAgICAgPGFwcC1wYXlyb2xsLXRpbWUgW3BheXJvbGxJbnZvaWNlXT1cInBheXJvbGxcIiBbaW5kZXhdPVwiaVwiIFtwYXJlbnRGb3JtXT1cInBheXJvbGxfZm9ybVwiXG4gICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgW2lzUmVhZE9ubHldPVwiIXBheXJvbGwucGF5X2ludGVycHJldGVyXCI+PC9hcHAtcGF5cm9sbC10aW1lPlxuICAgICAgICAgICAgICAgICAgICAgICAgICAgIDxhcHAtYm9va2luZy1yYXRlLWNhbHVsYXRpb24gKm5nSWY9J2lzRFNRJyBbcGF5cm9sbEludm9pY2VdPVwicGF5cm9sbFwiIFtpbmRleF09XCJpXCIgXG4gICAgICAgICAgICAgICAgICAgICAgICAgICAgW3BhcmVudEZvcm1dPVwicGF5cm9sbF9mb3JtXCIgW2lzUmVhZE9ubHldPVwiIXBheXJvbGwucGF5X2ludGVycHJldGVyXCI+XG4gICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIFxuICAgICAgICAgICAgICAgICAgICAgICAgICAgIDwvYXBwLWJvb2tpbmctcmF0ZS1jYWx1bGF0aW9uPlxuICAgICAgICAgICAgICAgICAgICAgICAgPC9zZWN0aW9uPlxuICAgICAgICAgICAgICAgICAgICAgICAgPHNlY3Rpb24gKm5nSWY9XCJwYXltZW50cy5pbnZvaWNlX2F0dHJpYnV0ZXNcIiBjbGFzcz1cInBheXJvbGwtY2FyZF9fY2xpZW50XCI+XG4gICAgICAgICAgICAgICAgICAgICAgICAgICAgPGhlYWRlciBpZD1cImNsaWVudC1pbnZvaWNlXCIgY2xhc3M9XCJwYXlyb2xsLWNhcmRfX2hlYWRlclwiPkludm9pY2Uge3tpKzF9fToge3twYXltZW50cy5pbnZvaWNlX2F0dHJpYnV0ZXNbaV0ub3JnYW5pc2F0aW9uX25hbWV9fSBmb3Ige3twYXlyb2xsLmludGVycHJldGVyX2ZpcnN0X25hbWVcbiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgKyAnICcgKyBwYXlyb2xsLmludGVycHJldGVyX2xhc3RfbmFtZX19PGJyLz5cbiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgPHNwYW4gY2xhc3M9XCJwYXlyb2xsX2lkXCI+SUQ6IHt7cGF5bWVudHMuaW52b2ljZV9hdHRyaWJ1dGVzW2ldLmlkfX08L3NwYW4+XG4gICAgICAgICAgICAgICAgICAgICAgICAgICAgPC9oZWFkZXI+XG4gICAgICAgICAgICAgICAgICAgICAgICAgICAgPHNlY3Rpb24gY2xhc3M9XCJwYXlyb2xsLWNhcmRfX2NvbnRlbnRcIj5cbiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgPHNlY3Rpb24+XG4gICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICA8ZGl2IGNsYXNzPVwicGF5cm9sbC1jYXJkX19vcHRpb25cIj5cbiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICA8bWQtY2hlY2tib3ggbmFtZT1cInt7J2NiSW52b2ljZUNsaWVudF8nICsgaX19XCJcbiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgWyhuZ01vZGVsKV09XCJwYXltZW50cy5pbnZvaWNlX2F0dHJpYnV0ZXNbaV0uaW52b2ljZV9jbGllbnRcIlxuICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAoY2hhbmdlKT1cImNiQ2hhbmdlZCgnaW52b2ljZV9hdHRyaWJ1dGVzJywnaW52b2ljZV9jbGllbnQnLGkpXCI+XG4gICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIEludm9pY2UgY2xpZW50XG4gICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIDxzcGFuIGNsYXNzPVwibm90ZSBub3RlX2Jsb2NrIG5vdGVfZ3JlZW4gbm90ZV9zbWFsbFwiICpuZ0lmPVwicGF5bWVudHMuaW52b2ljZV9hdHRyaWJ1dGVzW2ldLnJlY29tbWVuZGVkLmludm9pY2VfY2xpZW50XCI+UkVDT01NRU5ERUQ8L3NwYW4+XG4gICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIDxzcGFuIGNsYXNzPVwibm90ZSBub3RlX2Jsb2NrIG5vdGVfc21hbGxcIiAqbmdJZj1cIiFwYXltZW50cy5pbnZvaWNlX2F0dHJpYnV0ZXNbaV0ucmVjb21tZW5kZWQuaW52b2ljZV9jbGllbnRcIj5OT1QgUkVDT01NRU5ERUQ8L3NwYW4+XG4gICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgPC9tZC1jaGVja2JveD5cblxuICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgPC9kaXY+XG4gICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICA8ZGl2IGNsYXNzPVwicGF5cm9sbC1jYXJkX19vcHRpb24gcGF5cm9sbC1jYXJkX19vcHRpb25fd2l0aC1vZmZzZXRcIj5cbiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICA8bWQtY2hlY2tib3ggbmFtZT1cInt7J2NiQ2hhcmdlVHJhdmVsXycgK2l9fVwiXG4gICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIFsobmdNb2RlbCldPVwicGF5bWVudHMuaW52b2ljZV9hdHRyaWJ1dGVzW2ldLmNoYXJnZV90cmF2ZWxcIlxuICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICBbZGlzYWJsZWRdPVwiIXBheW1lbnRzLmludm9pY2VfYXR0cmlidXRlc1tpXS5pbnZvaWNlX2NsaWVudFwiXG4gICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIChjaGFuZ2UpPVwiY2JDaGFuZ2VkKCdpbnZvaWNlX2F0dHJpYnV0ZXMnLCdjaGFyZ2VfdHJhdmVsJyxpKVwiPlxuICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICBDaGFyZ2UgdHJhdmVsXG4gICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIDxzcGFuIGNsYXNzPVwibm90ZSBub3RlX2Jsb2NrIG5vdGVfZ3JlZW4gbm90ZV9zbWFsbFwiICpuZ0lmPVwicGF5bWVudHMuaW52b2ljZV9hdHRyaWJ1dGVzW2ldLnJlY29tbWVuZGVkLmNoYXJnZV90cmF2ZWxcIj5SRUNPTU1FTkRFRDwvc3Bhbj5cbiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgPHNwYW4gY2xhc3M9XCJub3RlIG5vdGVfYmxvY2sgbm90ZV9zbWFsbFwiICpuZ0lmPVwiIXBheW1lbnRzLmludm9pY2VfYXR0cmlidXRlc1tpXS5yZWNvbW1lbmRlZC5jaGFyZ2VfdHJhdmVsXCI+Tk9UIFJFQ09NTUVOREVEPC9zcGFuPlxuICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIDwvbWQtY2hlY2tib3g+XG4gICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICA8L2Rpdj5cbiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgPC9zZWN0aW9uPlxuICAgICAgICAgICAgICAgICAgICAgICAgICAgIDwvc2VjdGlvbj5cbiAgICAgICAgICAgICAgICAgICAgICAgICAgICA8YXBwLXBheXJvbGwtYWRkaXRpb25hbC1jb3N0cyAqbmdJZj0naXNEU1EnIFtwYXlyb2xsSW52b2ljZV09XCJwYXltZW50cy5pbnZvaWNlX2F0dHJpYnV0ZXNbaV1cIiBbaW5kZXhdPVwiaVwiIFxuICAgICAgICAgICAgICAgICAgICAgICAgICAgIFtwYXJlbnRGb3JtXT1cInBheXJvbGxfZm9ybVwiIFtpc1JlYWRPbmx5XT1cIiFwYXltZW50cy5pbnZvaWNlX2F0dHJpYnV0ZXNbaV0uaW52b2ljZV9jbGllbnRcIiAgW2lzQ2xpZW50XT1cInRydWVcIj5cbiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgXG4gICAgICAgICAgICAgICAgICAgICAgICAgICAgPC9hcHAtcGF5cm9sbC1hZGRpdGlvbmFsLWNvc3RzPlxuICAgICAgICAgICAgICAgICAgICAgICAgICAgIDxhcHAtcGF5cm9sbC10aW1lIFtwYXlyb2xsSW52b2ljZV09XCJwYXltZW50cy5pbnZvaWNlX2F0dHJpYnV0ZXNbaV1cIiBbaXNDbGllbnRdPVwidHJ1ZVwiXG4gICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgW2luZGV4XT1cImlcIiBbcGFyZW50Rm9ybV09XCJwYXlyb2xsX2Zvcm1cIlxuICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIFtpc1JlYWRPbmx5XT1cIiFwYXltZW50cy5pbnZvaWNlX2F0dHJpYnV0ZXNbaV0uaW52b2ljZV9jbGllbnRcIj48L2FwcC1wYXlyb2xsLXRpbWU+XG4gICAgICAgICAgICAgICAgICAgICAgICAgICAgPGFwcC1ib29raW5nLXJhdGUtY2FsdWxhdGlvbiAqbmdJZj0naXNEU1EnIFtwYXlyb2xsSW52b2ljZV09XCJwYXltZW50cy5pbnZvaWNlX2F0dHJpYnV0ZXNbaV1cIiBbaW5kZXhdPVwiaVwiIFxuICAgICAgICAgICAgICAgICAgICAgICAgICAgIFtwYXJlbnRGb3JtXT1cInBheXJvbGxfZm9ybVwiIFtpc1JlYWRPbmx5XT1cIiFwYXltZW50cy5pbnZvaWNlX2F0dHJpYnV0ZXNbaV0uaW52b2ljZV9jbGllbnRcIiAgW2lzQ2xpZW50XT1cInRydWVcIj5cbiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgXG4gICAgICAgICAgICAgICAgICAgICAgICAgICAgPC9hcHAtYm9va2luZy1yYXRlLWNhbHVsYXRpb24+XG4gICAgICAgICAgICAgICAgICAgICAgICA8L3NlY3Rpb24+XG4gICAgICAgICAgICAgICAgICAgIDwvc2VjdGlvbj5cbiAgICAgICAgICAgICAgICAgICAgPHNlY3Rpb24gKm5nSWY9XCIhcGF5bWVudHMucGF5cm9sbF9hdHRyaWJ1dGVzLmxlbmd0aFwiIGNsYXNzPVwicGF5cm9sbC1jYXJkXCIgI2VtcHR5UGF5cm9sbENvbnRhaW5lcj5cbiAgICAgICAgICAgICAgICAgICAgICAgIDxzZWN0aW9uIGNsYXNzPVwicGF5cm9sbC1jYXJkX19pbnRlcnByZXRlclwiPlxuICAgICAgICAgICAgICAgICAgICAgICAgICAgIDxoZWFkZXIgY2xhc3M9XCJwYXlyb2xsLWNhcmRfX2hlYWRlclwiPk5vIEludGVycHJldGVycyB3ZXJlIGFsbG9jYXRlZCB0byB0aGlzIGJvb2tpbmc8L2hlYWRlcj5cbiAgICAgICAgICAgICAgICAgICAgICAgIDwvc2VjdGlvbj5cbiAgICAgICAgICAgICAgICAgICAgPC9zZWN0aW9uPlxuICAgICAgICAgICAgICAgICAgICA8YnI+XG4gICAgICAgICAgICAgICAgPC9maWVsZHNldD5cbiAgICAgICAgICAgICAgICA8ZmllbGRzZXQ+XG4gICAgICAgICAgICAgICAgICAgIDxuZy1jb250YWluZXIgKm5nSWY9XCJpc0N1cnJlbnRVc2VyQWRtaW4oKSB8fCBpc0N1cnJlbnRVc2VyQk8oKVwiPlxuICAgICAgICAgICAgICAgICAgICAgICAgPGRpdiBjbGFzcz1cIm1lZGl1bS0xMlwiPlxuICAgICAgICAgICAgICAgICAgICAgICAgICAgIDxkaXYgY2xhc3M9XCJmb3JtLWZpZWxkXCI+XG4gICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIDxoMj5DTEFJTSBOT1RFUzwvaDI+XG4gICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIDx0ZXh0YXJlYSB0eXBlPVwidGV4dFwiIGNsYXNzPVwiaW5saW5lLWljb24gaW5saW5lLWljb24tdHh0XCJcbiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIFsobmdNb2RlbCldPVwiYm9va2luZ01vZGVsLmNsYWltX25vdGVzXCIgY29scz1cIjMwXCIgcm93cz1cIjEwXCIgbmFtZT1cImNsYWltX25vdGVzXCI+XG4gICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIDwvdGV4dGFyZWE+XG4gICAgICAgICAgICAgICAgICAgICAgICAgICAgPC9kaXY+XG4gICAgICAgICAgICAgICAgICAgICAgICA8L2Rpdj5cbiAgICAgICAgICAgICAgICAgICAgPC9uZy1jb250YWluZXI+XG4gICAgICAgICAgICAgICAgPC9maWVsZHNldD5cbiAgICAgICAgICAgICAgICA8ZGl2ICpuZ0lmPVwicGF5bWVudHMucGF5cm9sbF9hdHRyaWJ1dGVzLmxlbmd0aCA+IDBcIiBjbGFzcz1cImFjdGlvbnNcIj5cbiAgICAgICAgICAgICAgICAgICAgPGJ1dHRvbiBuYW1lPVwiYnRuU2F2ZVwiIChjbGljayk9XCJ1cGRhdGVQYXltZW50KHBheXJvbGxfZm9ybSlcIj5cbiAgICAgICAgICAgICAgICAgICAgICAgIHt7aXNEU1EgJiYgaXNTdGF0ZUNvbXBsZXRlT3JDYW5jZWxDaGFyZ2UoKSA/IFwiQ2xhaW0gJiBTYXZlXCIgOiBcIlNhdmVcIn19PC9idXR0b24+XG4gICAgICAgICAgICAgICAgPC9kaXY+XG4gICAgICAgICAgICAgICAgPG5nLWNvbnRhaW5lciAqbmdJZj1cImlzQ3VycmVudFVzZXJBZG1pbigpIHx8IGlzQ3VycmVudFVzZXJCTygpXCI+XG4gICAgICAgICAgICAgICAgICAgIDxoMiBuYW1lPVwicGF5bWVudC1oaXN0b3J5XCIgY2xhc3M9XCJoaWRkZW4tbW9iaWxlXCI+UGF5cm9sbCBIaXN0b3J5PC9oMj5cbiAgICAgICAgICAgICAgICAgICAgPHRhYmxlIGlkPVwiY2hhbmdlcy1oaXN0b3J5XCIgY2xhc3M9XCJjdXN0b20tc21hbGwtdGFibGVcIj5cbiAgICAgICAgICAgICAgICAgICAgICAgIDx0aGVhZD5cbiAgICAgICAgICAgICAgICAgICAgICAgICAgICA8dGggd2lkdGg9XCIyMCVcIj5EYXRlIGFuZCBUaW1lPC90aD5cbiAgICAgICAgICAgICAgICAgICAgICAgICAgICA8dGggd2lkdGg9XCIzMCVcIj5BY3Rpb248L3RoPlxuICAgICAgICAgICAgICAgICAgICAgICAgICAgIDx0aD5DaGFuZ2VzPC90aD5cbiAgICAgICAgICAgICAgICAgICAgICAgIDwvdGhlYWQ+XG4gICAgICAgICAgICAgICAgICAgICAgICA8dGJvZHk+XG4gICAgICAgICAgICAgICAgICAgICAgICAgICAgPHRyICpuZ0Zvcj1cImxldCB2ZXJzaW9uIG9mIHBheW1lbnRzLnZlcnNpb25zOyBsZXQgaT1pbmRleFwiPlxuICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICA8dGQgbmFtZT1cImRhdGFfY3JlYXRlZF9hdFwiPlxuICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAge3t2ZXJzaW9uLmNyZWF0ZWRfYXRfaXNvIHwgZGF0ZTonc2hvcnRUaW1lJ319IG9uXG4gICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICB7e3ZlcnNpb24uY3JlYXRlZF9hdF9pc28gfCBtb21lbnRUWkRhdGUgOiBib29raW5nTW9kZWwudmVudWUuc3RhdGUgOiBib29raW5nTW9kZWwudmVudWUucG9zdF9jb2RlfX1cbiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgPC90ZD5cbiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgPHRkPlxuICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgPGltZyBoZWlnaHQ9XCIzMHB4XCIgd2lkdGg9XCIzMHB4XCIgc3JjPVwiXCIgYWx0PVwiXCI+XG4gICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICA8c3BhbiBjbGFzcz1cImRpc3BsYXktZmx4XCIgbmFtZT1cImRhdGFfYWN0aW9uXCI+XG4gICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAge3t2ZXJzaW9uLmJvb2tpbmdfZXZlbnRfZm9ybWF0dGVkKCl9fVxuICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIDxici8+IHt7dmVyc2lvbi5mdWxsX25hbWUoKX19XG4gICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICA8L3NwYW4+XG4gICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIDwvdGQ+XG4gICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIDx0ZD5cbiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIDxkaXYgbmFtZT1cImRhdGFfY2hhbmdlc1wiPlxuICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIDxkaXY+XG4gICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIDxzcGFuICpuZ0lmPVwidmVyc2lvbi5tb2RlbCAhPT0gJ0Jvb2tpbmcnXCIgc3R5bGU9XCJmb250LXN0eWxlOiBvYmxpcXVlOyBmb250LXdlaWdodDogYm9sZGVyXCI+e3t2ZXJzaW9uLm1vZGVsfX0gSUQ6IHt7dmVyc2lvbi5vYmplY3RfaWR9fTwvc3Bhbj5cbiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgPHNwYW4gKm5nSWY9XCJ2ZXJzaW9uLm1vZGVsID09PSAnQm9va2luZydcIiBzdHlsZT1cImZvbnQtc3R5bGU6IG9ibGlxdWU7IGZvbnQtd2VpZ2h0OiBib2xkZXJcIj57e3ZlcnNpb24ubW9kZWx9fSBJRDoge3tib29raW5nTW9kZWwuaWR9fTwvc3Bhbj5cbiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICA8L2Rpdj5cbiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICA8ZGl2ICpuZ0Zvcj1cImxldCBjaGFuZ2VfaXRlbV9rZXkgb2YgdmVyc2lvbi5jaGFuZ2Vfc2V0X2Zvcm1hdHRlZF9oYXNoKClcIj5cbiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgPGI+e3tjaGFuZ2VfaXRlbV9rZXlbMF19fTogPC9iPnt7Y2hhbmdlX2l0ZW1fa2V5WzFdWzBdfX1cbiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgPGI+dG88L2I+XG4gICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIDxzcGFuPnt7Y2hhbmdlX2l0ZW1fa2V5WzFdWzFdfX08L3NwYW4+XG4gICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgPC9kaXY+XG4gICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICA8L2Rpdj5cbiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgPC90ZD5cbiAgICAgICAgICAgICAgICAgICAgICAgICAgICA8L3RyPlxuICAgICAgICAgICAgICAgICAgICAgICAgPC90Ym9keT5cbiAgICAgICAgICAgICAgICAgICAgPC90YWJsZT5cbiAgICAgICAgICAgICAgICA8L25nLWNvbnRhaW5lcj5cbiAgICAgICAgICAgIDwvZm9ybT5cbiAgICAgICAgPC9tYWluPlxuICAgIDwvc2VjdGlvbj5cbjwvc2VjdGlvbj5cbiIsIjxhcHAtYm9va2luZy1wYXlyb2xsPjwvYXBwLWJvb2tpbmctcGF5cm9sbD4iXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztNQ3FDNEM7UUFBQTtRQUFBO01BQUE7SUFBQTtJQUFnRzs7Ozs7O01BQ2hHO1FBQUE7UUFBQTtNQUFBO0lBQUE7SUFBc0Y7Ozs7OztNQVF0RjtRQUFBO1FBQUE7TUFBQTtJQUFBO0lBQTJGOzs7Ozs7TUFDM0Y7UUFBQTtRQUFBO01BQUE7SUFBQTtJQUFpRjs7Ozs7O0lBS2pHO2dCQUFBO01BQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO01BQUE7O0lBQUE7S0FBQTs7O0lBQThCO0lBQTJCO0lBQVk7SUFDdEM7SUFEL0IsU0FBOEIsVUFBMkIsVUFBWSxVQUN0QyxTQUQvQjs7Ozs7SUFJQTtnQkFBQTtNQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtNQUFBOztJQUFBO0tBQUE7SUFDb0U7OztJQUR6QjtJQUEyQjtJQUN0RTtJQUE0QjtJQUQ1QixTQUEyQyxVQUEyQixVQUN0RSxVQUE0QixTQUQ1Qjs7Ozs7TUFpQmdCO1FBQUE7UUFBQTtNQUFBO0lBQUE7SUFBc0g7Ozs7OztNQUN0SDtRQUFBO1FBQUE7TUFBQTtJQUFBO0lBQTRHOzs7Ozs7TUFVNUc7UUFBQTtRQUFBO01BQUE7SUFBQTtJQUFxSDs7Ozs7O01BQ3JIO1FBQUE7UUFBQTtNQUFBO0lBQUE7SUFBMkc7Ozs7OztJQUszSDtnQkFBQTtNQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtNQUFBOztJQUFBO0tBQUE7SUFDNkc7Ozs7SUFEakU7SUFBa0Q7SUFDSDtJQUEzRjtJQUE0QjtJQUQ1QixTQUE0QyxVQUFrRCxVQUNILFVBQTNGLFVBQTRCLFNBRDVCOzs7OztJQU9BO2dCQUFBO01BQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO01BQUE7O0lBQUE7S0FBQTtJQUM2Rzs7OztJQURsRTtJQUFrRDtJQUNGO0lBQTNGO0lBQTRCO0lBRDVCLFNBQTJDLFVBQWtELFVBQ0YsVUFBM0YsVUFBNEIsU0FENUI7Ozs7O01BcENKO1FBQUE7UUFBQTtNQUFBO0lBQUE7SUFBMEU7SUFDdEU7TUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7TUFBQTs7SUFBQTtLQUFBO0lBQXlEO01BQUE7TUFBQTtNQUFBO01BQUE7SUFBQTtJQUFBO0lBQ2Q7SUFBSztNQUM1QztRQUFBO1FBQUE7TUFBQTtJQUFBO0lBQXlCO01BQUE7TUFBQTtJQUFBO0lBQUE7SUFBZ0Q7SUFDcEU7TUFDVDtRQUFBO1FBQUE7TUFBQTtJQUFBO0lBQXVDO0lBQ25DO0lBQVM7TUFDTDtRQUFBO1FBQUE7TUFBQTtJQUFBO0lBQWtDO01BQzlCO1FBQUE7UUFBQTtNQUFBO0lBQUE7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O0lBQUE7S0FBQTtNQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtNQUFBOztJQUFBO0tBQUE7TUFBQTtNQUFBO01BQ2E7UUFBQTtRQUFBO01BQUE7TUFDQTtRQUFBO1FBQUE7TUFBQTtNQUZiO0lBQUE7Z0JBQUE7TUFBQTtRQUFBOztNQUFBOzs7SUFBQTtLQUFBO2dCQUFBOzs7OztJQUFBO09BQUE7UUFBQTtRQUFBO01BQUE7SUFBQTtnQkFBQTtNQUFBO0lBQUE7Z0JBQUE7TUFBQTtRQUFBOztNQUFBOztNQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7O01BQUE7O0lBQUE7S0FBQTtNQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtNQUFBOztJQUFBO0tBQUE7Z0JBQUE7Z0JBQUE7a0JBQUE7UUFBQTs7TUFBQTtJQUFBO0lBRTJFO0lBRXZFO2dCQUFBOzs7SUFBQTtPQUFBO1FBQUE7UUFBQTtNQUFBO0lBQUE7SUFBd0k7SUFDeEk7Z0JBQUE7OztJQUFBO09BQUE7UUFBQTtRQUFBO01BQUE7SUFBQTtJQUFrSTtJQUN4SDtJQUVaO01BQ047UUFBQTtRQUFBO01BQUE7SUFBQTtJQUFtRTtNQUMvRDtRQUFBO1FBQUE7TUFBQTtJQUFBO01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztJQUFBO0tBQUE7TUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7TUFBQTs7SUFBQTtLQUFBO01BQUE7TUFBQTtNQUNhO1FBQUE7UUFBQTtNQUFBO01BRUE7UUFBQTtRQUFBO01BQUE7TUFIYjtJQUFBO2dCQUFBO01BQUE7UUFBQTs7TUFBQTs7O0lBQUE7S0FBQTtnQkFBQTs7Ozs7SUFBQTtLQUFBO01BQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO01BQUE7O0lBQUE7S0FBQTtnQkFBQTtNQUFBO0lBQUE7Z0JBQUE7TUFBQTtRQUFBOztNQUFBOztNQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7O01BQUE7O0lBQUE7S0FBQTtNQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtNQUFBOztJQUFBO0tBQUE7Z0JBQUE7Z0JBQUE7a0JBQUE7UUFBQTs7TUFBQTtJQUFBO0lBRzBFO0lBRXRFO2dCQUFBOzs7SUFBQTtPQUFBO1FBQUE7UUFBQTtNQUFBO0lBQUE7SUFBdUk7SUFDdkk7Z0JBQUE7OztJQUFBO09BQUE7UUFBQTtRQUFBO01BQUE7SUFBQTtJQUFpSTtJQUN2SDtJQUNaO0lBQ0E7SUFDSjtJQUNWO2dCQUFBOzs7SUFBQTtPQUFBO1FBQUE7UUFBQTtNQUFBO0lBQUE7SUFHK0I7SUFDL0I7Z0JBQUE7TUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7TUFBQTs7SUFBQTtLQUFBO0lBRW1HO0lBQ25HO2dCQUFBOzs7SUFBQTtPQUFBO1FBQUE7UUFBQTtNQUFBO0lBQUE7SUFHOEI7Ozs7SUEvQkw7SUFBYixVQUFhLFVBQWI7SUFBYTtJQUNBO0lBRGIsVUFBYSxXQUNBLFVBRGI7SUFJd0Q7SUFBcEQsVUFBb0QsVUFBcEQ7SUFDeUM7SUFBekMsVUFBeUMsVUFBekM7SUFPUztJQUZBO0lBQWIsVUFFYSxXQUZBLFVBQWI7SUFBYTtJQUVBO0lBREE7SUFEYixVQUFhLFdBRUEsV0FEQSxVQURiO0lBS3dEO0lBQXBELFVBQW9ELFVBQXBEO0lBQ3lDO0lBQXpDLFVBQXlDLFVBQXpDO0lBS2M7SUFBOUIsVUFBOEIsVUFBOUI7SUFJa0I7SUFDQTtJQURrRDtJQUN0QztJQUNaO0lBRmxCLFVBQWtCLFdBQ0EsV0FEa0QsV0FDdEMsV0FDWixVQUZsQjtJQUc2QjtJQUE3QixVQUE2QixVQUE3Qjs7O0lBbkN5RDtJQUFBO0lBQUE7SUFBQTtJQUU1QjtJQUFBO0lBS2pCO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtNQUFBO01BQUE7TUFBQTtNQUFBO01BQUE7TUFBQTtNQUFBO01BQUE7TUFBQTtNQUFBO01BQUE7SUFBQTtJQUFBO0lBVUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO01BQUE7TUFBQTtNQUFBO01BQUE7TUFBQTtNQUFBO01BQUE7TUFBQTtNQUFBO01BQUE7TUFBQTtJQUFBO0lBQUE7Ozs7O01BckVwQjtRQUFBO1FBQUE7TUFBQTtJQUFBO0lBQWlHO01BQzdGO1FBQUE7UUFBQTtNQUFBO0lBQUE7SUFBMkM7TUFDdkM7UUFBQTtRQUFBO01BQUE7SUFBQTtJQUFxQztNQUFBO01BQUE7TUFBQTtJQUFBO0lBQUE7SUFDRztJQUFLO01BQ3pDO1FBQUE7UUFBQTtNQUFBO0lBQUE7SUFBeUI7TUFBQTtNQUFBO0lBQUE7SUFBQTtJQUF5QjtJQUM3QztNQUNUO1FBQUE7UUFBQTtNQUFBO0lBQUE7SUFBdUM7TUFDbkM7UUFBQTtRQUFBO01BQUE7SUFBQTtJQUE2QjtNQUV6QjtRQUFBO1FBQUE7TUFBQTtJQUFBO0lBQXdCO0lBQ3BCO01BQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO01BQUE7O0lBQUE7S0FBQTtNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O0lBQUE7S0FBQTtNQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtNQUFBOztJQUFBO0tBQUE7TUFBQTtNQUFBO1FBQUE7UUFBQTtNQUFBO01BQUE7UUFBQTtRQUFBO01BQUE7TUFBb0M7UUFBQTtRQUFBO01BQUE7TUFBcEM7SUFBQTtnQkFBQTs7O0lBQUE7S0FBQTtnQkFBQTtNQUFBO0lBQUE7Z0JBQUE7TUFBQTtRQUFBOztNQUFBOztNQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7O01BQUE7O0lBQUE7S0FBQTtNQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtNQUFBOztJQUFBO0tBQUE7Z0JBQUE7Z0JBQUE7SUFDMEM7SUFDdEM7Z0JBQUE7OztNQUFBO1FBQUE7O01BQUE7O0lBQUE7T0FBQTtRQUFBO1FBQUE7TUFBQTtJQUFBO2dCQUFBOzs7TUFBQTtRQUFBO1FBQUE7TUFBQTs7SUFBQTtPQUFBO1FBQUE7UUFBQTtNQUFBO0lBQUE7SUFBcUM7TUFBQTtNQUFBO0lBQUE7SUFBQTtJQUM1QjtJQUNFO0lBQ2I7TUFDVjtRQUFBO1FBQUE7TUFBQTtJQUFBO0lBQXFDO0lBRWpDO01BQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO01BQUE7O0lBQUE7S0FBQTtJQUNrQztNQUFBO01BQUE7SUFBQTtJQUFBO0lBQXVEO0lBQ25GO0lBQ1Y7SUFBUztNQUNMO1FBQUE7UUFBQTtNQUFBO0lBQUE7SUFBa0M7TUFDOUI7UUFBQTtRQUFBO01BQUE7SUFBQTtNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7SUFBQTtLQUFBO01BQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO01BQUE7O0lBQUE7S0FBQTtNQUFBO01BQUE7TUFDYTtRQUFBO1FBQUE7TUFBQTtNQUNBO1FBQUE7UUFBQTtNQUFBO01BRmI7SUFBQTtnQkFBQTtNQUFBO1FBQUE7O01BQUE7OztJQUFBO0tBQUE7Z0JBQUE7Ozs7O0lBQUE7T0FBQTtRQUFBO1FBQUE7TUFBQTtJQUFBO2dCQUFBO01BQUE7SUFBQTtnQkFBQTtNQUFBO1FBQUE7O01BQUE7O01BQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTs7TUFBQTs7SUFBQTtLQUFBO01BQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO01BQUE7O0lBQUE7S0FBQTtnQkFBQTtnQkFBQTtrQkFBQTtRQUFBOztNQUFBO0lBQUE7SUFFNEU7SUFFeEU7Z0JBQUE7OztJQUFBO09BQUE7UUFBQTtRQUFBO01BQUE7SUFBQTtJQUFrSDtJQUNsSDtnQkFBQTs7O0lBQUE7T0FBQTtRQUFBO1FBQUE7TUFBQTtJQUFBO0lBQTRHO0lBQ2xHO0lBQ1o7TUFDTjtRQUFBO1FBQUE7TUFBQTtJQUFBO0lBQW1FO01BQy9EO1FBQUE7UUFBQTtNQUFBO0lBQUE7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O0lBQUE7S0FBQTtNQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtNQUFBOztJQUFBO0tBQUE7TUFBQTtNQUFBO01BQTJDO1FBQUE7UUFBQTtNQUFBO01BRTlCO1FBQUE7UUFBQTtNQUFBO01BRmI7SUFBQTtnQkFBQTtNQUFBO1FBQUE7O01BQUE7OztJQUFBO0tBQUE7Z0JBQUE7Ozs7O0lBQUE7S0FBQTtNQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtNQUFBOztJQUFBO0tBQUE7Z0JBQUE7TUFBQTtJQUFBO2dCQUFBO01BQUE7UUFBQTs7TUFBQTs7TUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBOztNQUFBOztJQUFBO0tBQUE7TUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7TUFBQTs7SUFBQTtLQUFBO2dCQUFBO2dCQUFBO2tCQUFBO1FBQUE7O01BQUE7SUFBQTtJQUV1RTtJQUVuRTtnQkFBQTs7O0lBQUE7T0FBQTtRQUFBO1FBQUE7TUFBQTtJQUFBO0lBQTZHO0lBQzdHO2dCQUFBOzs7SUFBQTtPQUFBO1FBQUE7UUFBQTtNQUFBO0lBQUE7SUFBdUc7SUFDN0Y7SUFDWjtJQUNBO0lBQ0o7SUFDVjtnQkFBQTs7O0lBQUE7T0FBQTtRQUFBO1FBQUE7TUFBQTtJQUFBO0lBQ3NHO0lBQ3RHO2dCQUFBO01BQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO01BQUE7O0lBQUE7S0FBQTtJQUM2RTtJQUM3RTtnQkFBQTs7O0lBQUE7T0FBQTtRQUFBO1FBQUE7TUFBQTtJQUFBO0lBRzhCO0lBQ3hCO0lBQ1Y7Z0JBQUE7OztJQUFBO09BQUE7UUFBQTtRQUFBO01BQUE7SUFBQTtJQXdDVTs7OztJQWpGYztJQUN5QjtJQURHO0lBQXBDLFVBQVEsV0FDeUIsV0FERyxVQUFwQztJQUVZO0lBQVIsVUFBUSxVQUFSO0lBQVE7SUFBUixVQUFRLFVBQVI7SUFXUztJQUFiLFVBQWEsVUFBYjtJQUFhO0lBQ0E7SUFEYixVQUFhLFdBQ0EsVUFEYjtJQUl3RDtJQUFwRCxVQUFvRCxVQUFwRDtJQUN5QztJQUF6QyxVQUF5QyxVQUF6QztJQUtTO0lBREE7SUFBYixVQUNhLFdBREEsVUFBYjtJQUFhO0lBQ0E7SUFEOEI7SUFBM0MsVUFBYSxXQUNBLFdBRDhCLFVBQTNDO0lBSXdEO0lBQXBELFVBQW9ELFVBQXBEO0lBQ3lDO0lBQXpDLFVBQXlDLFVBQXpDO0lBTUg7SUFEYixVQUNhLFVBRGI7SUFFa0I7SUFBMkI7SUFBWTtJQUN2QztJQURsQixVQUFrQixXQUEyQixXQUFZLFdBQ3ZDLFVBRGxCO0lBRTZCO0lBQTdCLFVBQTZCLFVBQTdCO0lBS0s7SUFBVCxVQUFTLFVBQVQ7O0lBakR5QztJQUFBO0lBQUE7SUFFUjtJQUFBO0lBTWpCO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUEsVUFBQSxxRUFBQTtJQUV5QztJQUFBO0lBT1g7SUFBQTtJQUk5QjtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7TUFBQTtNQUFBO01BQUE7TUFBQTtNQUFBO01BQUE7TUFBQTtNQUFBO01BQUE7TUFBQTtNQUFBO0lBQUE7SUFBQTtJQVNBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtNQUFBO01BQUE7TUFBQTtNQUFBO01BQUE7TUFBQTtNQUFBO01BQUE7TUFBQTtNQUFBO01BQUE7SUFBQTtJQUFBOzs7OztNQTZEcEI7UUFBQTtRQUFBO01BQUE7TUFBQTtRQUFBO1FBQUE7TUFBQTtJQUFBO0lBQWlHO01BQzdGO1FBQUE7UUFBQTtNQUFBO0lBQUE7SUFBMkM7TUFDdkM7UUFBQTtRQUFBO01BQUE7SUFBQTtJQUFxQztJQUF1RDtJQUN0Rjs7Ozs7O0lBS2Q7SUFBZ0U7TUFDNUQ7UUFBQTtRQUFBO01BQUE7SUFBQTtJQUF1QjtNQUNuQjtRQUFBO1FBQUE7TUFBQTtJQUFBO0lBQXdCO0lBQ3BCO0lBQUk7SUFBZ0I7SUFDcEI7TUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7TUFBQTs7SUFBQTtLQUFBO01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7SUFBQTtLQUFBO01BQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO01BQUE7O0lBQUE7S0FBQTtNQUFBO01BQUE7TUFBQTtRQUFBO1FBQUE7TUFBQTtNQUFBO1FBQUE7UUFBQTtNQUFBO01BQUE7UUFBQTtRQUFBO01BQUE7TUFBQTtRQUFBO1FBQUE7TUFBQTtNQUNVO1FBQUE7UUFBQTtNQUFBO01BRFY7SUFBQTtnQkFBQTs7O01BQUE7UUFBQTs7TUFBQTs7SUFBQTtLQUFBO2dCQUFBO01BQUE7SUFBQTtnQkFBQTtNQUFBO1FBQUE7O01BQUE7O01BQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTs7TUFBQTs7SUFBQTtLQUFBO01BQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO01BQUE7O0lBQUE7S0FBQTtnQkFBQTtnQkFBQTtJQUN3RjtJQUM3RTtJQUNUO0lBQ0o7Ozs7SUFIdUU7SUFBM0Q7SUFEVixVQUNxRSxVQUEzRCxTQURWOztJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUEsU0FBQSxxRUFBQTs7Ozs7TUFPaEI7UUFBQTtRQUFBO01BQUE7SUFBQTtJQUFvRTtNQUNoRTtRQUFBO1FBQUE7TUFBQTtNQUFBO1FBQUE7UUFBQTtNQUFBO0lBQUE7TUFBQTtNQUFBO01BQXVCO1FBQUE7UUFBQTtNQUFBO01BQXZCO0lBQUE7SUFBNkQ7TUFBQTtNQUFBO0lBQUE7SUFBQTtJQUNzQjs7OztJQUR0QjtJQUFBOzs7OztNQTJCckM7UUFBQTtRQUFBO01BQUE7SUFBQTtJQUEyRjtNQUFBO01BQUE7TUFBQTtJQUFBO0lBQUE7OztJQUFBO0lBQUE7SUFBQTs7Ozs7TUFDM0Y7UUFBQTtRQUFBO01BQUE7SUFBQTtJQUEyRjtNQUFBO01BQUE7TUFBQTtJQUFBO0lBQUE7Ozs7SUFBQTtJQUFBO0lBQUE7Ozs7O0lBRS9GO0lBQXlFO0lBQ3JFO0lBQUc7TUFBQTtNQUFBO0lBQUE7SUFBQTtJQUE0QjtNQUFBO01BQUE7SUFBQTtJQUFBO0lBQy9CO0lBQUc7SUFBTTtJQUNUO0lBQU07TUFBQTtNQUFBO0lBQUE7SUFBQTtJQUFnQzs7O0lBRm5DO0lBQUE7SUFBNEI7SUFBQTtJQUV6QjtJQUFBOzs7OztJQXJCdEI7SUFBMkQ7TUFDdkQ7UUFBQTtRQUFBO01BQUE7SUFBQTtJQUEyQjtNQUFBO01BQUE7TUFBQTtJQUFBO0lBQUE7Z0JBQUE7Z0JBQUE7SUFHdEI7SUFDTDtJQUFJO0lBQ0E7TUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7TUFBQTs7SUFBQTtLQUFBO0lBQThDO0lBQzlDO01BQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO01BQUE7O0lBQUE7S0FBQTtJQUE2QztNQUFBO01BQUE7SUFBQTtJQUFBO0lBRXpDO0lBQUs7TUFBQTtNQUFBO0lBQUE7SUFBQTtJQUNGO0lBQ047SUFDTDtJQUFJO01BQ0E7UUFBQTtRQUFBO01BQUE7SUFBQTtJQUF5QjtJQUNyQjtJQUFLO0lBQ0Q7Z0JBQUE7OztJQUFBO09BQUE7UUFBQTtRQUFBO01BQUE7SUFBQTtJQUE2STtJQUM3STtnQkFBQTs7O0lBQUE7T0FBQTtRQUFBO1FBQUE7TUFBQTtJQUFBO0lBQTJJO0lBQ3pJO0lBQ047Z0JBQUE7Ozs7SUFBQTtPQUFBO1FBQUE7UUFBQTtNQUFBO0lBQUE7SUFJTTtJQUNKO0lBQ0w7OztJQVRhO0lBQU4sVUFBTSxTQUFOO0lBQ007SUFBTixVQUFNLFNBQU47SUFFQztJQUFMLFVBQUssU0FBTDs7O0lBakJtQjtJQUFBO0lBQUE7SUFNc0I7SUFBQTtJQUVwQztJQUFBOzs7OztJQWxCN0I7SUFBZ0U7SUFDNUQ7TUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7TUFBQTs7SUFBQTtLQUFBO0lBQWlEO0lBQW9CO0lBQ3JFO01BQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO01BQUE7O0lBQUE7S0FBQTtJQUF1RDtJQUNuRDtJQUFPO01BQ0g7UUFBQTtRQUFBO01BQUE7SUFBQTtJQUFnQjtJQUFrQjtNQUNsQztRQUFBO1FBQUE7TUFBQTtJQUFBO0lBQWdCO0lBQVc7SUFDM0I7SUFBSTtJQUFZO0lBQ1o7SUFDUjtJQUFPO0lBQ0g7Z0JBQUE7Ozs7SUFBQTtPQUFBO1FBQUE7UUFBQTtNQUFBO0lBQUE7SUF5Qks7SUFDRDtJQUNKOzs7O0lBM0JJO0lBQUosVUFBSSxTQUFKOzs7Ozs7O01Bdkk1QjtRQUFBO1FBQUE7TUFBQTtJQUFBO0lBQTBCO0lBQ3RCO2dCQUFBOzs7Ozs7O0lBQUE7S0FBQTtNQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtNQUFBOztJQUFBO0tBQUE7SUFDbUU7TUFDbkU7UUFBQTtRQUFBO01BQUE7SUFBQTtJQUEwQjtJQUN0QjtJQUFNO0lBQ0Y7TUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7TUFBQTs7SUFBQTtLQUFBO01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7SUFBQTtLQUFBO01BQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO01BQUE7O0lBQUE7S0FBQTtNQUFBO01BQUE7UUFBQTtRQUFBO01BQUE7TUFBQTtRQUFBO1FBQUE7TUFBQTtNQUFBO0lBQUE7Z0JBQUE7a0JBQUE7UUFBQTtRQUFBO01BQUE7SUFBQTtNQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtNQUFBOztJQUFBO0tBQUE7Z0JBQUE7Z0JBQUE7SUFBNkQ7SUFDekQ7a0JBQUE7UUFBQTtRQUFBO01BQUE7SUFBQTtJQUEyRTtJQUUzRTtJQUFJO0lBQW9CO01BQ3hCO1FBQUE7UUFBQTtNQUFBO0lBQUE7SUFBd0M7SUFDcEM7Z0JBQUE7Ozs7SUFBQTtPQUFBO1FBQUE7UUFBQTtNQUFBO0lBQUE7SUE0RlU7SUFDVjtnQkFBQTs7O0lBQUE7T0FBQTtRQUFBO1FBQUE7TUFBQTtJQUFBO0lBSVU7SUFDVjtJQUFJO0lBQ0c7SUFDWDtJQUFVO0lBQ047Z0JBQUE7OztJQUFBO09BQUE7UUFBQTtRQUFBO01BQUE7SUFBQTtJQVNlO0lBQ1I7SUFDWDtnQkFBQTs7O0lBQUE7T0FBQTtRQUFBO1FBQUE7TUFBQTtJQUFBO0lBR007SUFDTjtnQkFBQTs7O0lBQUE7T0FBQTtRQUFBO1FBQUE7TUFBQTtJQUFBO0lBcUNlO0lBQ1o7SUFDSjtJQUNEO0lBQ0o7Ozs7SUF0S29DO0lBQ3RCO0lBRG9EO0lBQXBEO0lBQXBCLFNBQTBDLFVBQ3RCLFVBRG9ELFVBQXBELFNBQXBCO0lBSzhCO0lBQWxCLFVBQWtCLFVBQWxCO0lBSWE7SUFBVCxVQUFTLFVBQVQ7SUE2RlM7SUFBVCxVQUFTLFVBQVQ7SUFRYztJQUFkLFVBQWMsVUFBZDtJQVdDO0lBQUwsVUFBSyxVQUFMO0lBSWM7SUFBZCxVQUFjLFVBQWQ7O0lBekhKO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUEsVUFBQSxzRUFBQTs7Ozs7SUNMWjtnQkFBQTs7Ozs7SUFBQTtLQUFBOzs7SUFBQTs7OyJ9



// WEBPACK FOOTER //
// ./src/$$_gendir/app/booking-management/booking-payroll/booking-payroll.component.ngfactory.ts